import {
  getAllCollectionFinderOptions,
  getCollectionFieldTraitOptions,
  getCollectionOptionsForSelect,
  getExternalAPIOptionsForSelect,
  getFieldOptionsForSelect,
  getFinderFieldsOptions,
  getInstalledPlugins,
  getLocalizationOptionsForSelect,
} from '../pluginComponentApi';

export default async function (editor, opt = {}) {
  const {
    bindCollectionOptions,
    snippetCollectionTraitOptions,
    projectId,
    collections,
    traits,
    version,
    externalApis,
  } = opt;
  const traitManager = editor.TraitManager;
  let { collection, session, sessionTenant, sessionUserSettings, sessionSubTenant } =
    bindCollectionOptions;

  if (!collection) {
    collection = snippetCollectionTraitOptions.collection;
  }

  let { collectionId: pageCollectionId } = collection || '';
  console.log('🚀 ~ file: traits.js:30 ~ function ~ Page Collection Id:', pageCollectionId);
  const dataCollectionFieldName = collection ? `data-${collection.collectionId}` : '';
  const dataURLCollectionFieldName = collection ? `data-url-${collection.collectionId}` : '';
  const dataSessionFieldName = `data-session`;
  const dataSessionTextFieldName = `data-session-text`;
  const dataSessionTenantFieldName = `data-session-tenant`;
  const dataSessionUserSettingFieldName = `data-session-user-settings`;
  const dataSessionSubTenantFieldName = `data-session-sub-tenant`;
  const dataFilter = `data-filter-id`;
  const dataFilterCollection = `data-filter-collection`;
  let componentContent = '';
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        input[type=webconnect-text] {
            display:block;
        }
  `;
  document.head.appendChild(style);
  const localization = projectId ? await getLocalizationOptionsForSelect(projectId) : '';
  const installedPlugins = projectId ? await getInstalledPlugins(projectId, version) : '';
  console.log('🚀 ~ file: traits.js:58 ~ function ~ installedPlugins:', installedPlugins);
  const multiTenantPlugin =
    installedPlugins && installedPlugins.find((plugin) => plugin.code === 'MULTI_TENANT_SAAS');
  const hasMultiTenantPlugin = !!multiTenantPlugin;
  if (
    collection ||
    session ||
    sessionTenant ||
    localization ||
    sessionUserSettings ||
    sessionSubTenant
  ) {
    traitManager.addType(traits.text.type, {
      createInput({ trait }) {
        componentContent = trait.attributes.content;
        const customLabel = 'Get Value From';
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
        <div id="URL">
          <div class="gjs-container">
            <div class="gjs-row">
              <div class="gjs-label-wrp">
                <div class="gjs-label" title="Get Content">Get Content</div>
              </div>
              <div id="select-getTextFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getTextFrom">
                <div class="gjs-field">
                  <select class="select-getTextFrom form-control form-control-sm options-light">
                    <option value="" selected>- Get Content -</option>
                    ${
                      collection &&
                      `<option value="collection">${customLabel} ${collection.collectionTitle}</option>`
                    }
                    ${
                      session &&
                      `
                      <option value="session">${customLabel} Logged In User</option>
                    `
                    }
                    ${
                      sessionTenant &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionTenant">${customLabel} Logged In ${sessionTenant.collectionTitle}</option>
                    `
                    }
                    ${
                      sessionUserSettings &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionUserSettings">${customLabel} Logged In ${sessionUserSettings.collectionTitle}</option>
                    `
                    }
                    ${
                      sessionSubTenant &&
                      hasMultiTenantPlugin &&
                      `
                      <option value="sessionSubTenant">${customLabel} Logged In ${sessionSubTenant.collectionTitle}</option>
                    `
                    }
                    <option value="BROWSER_STORAGE_LOCATION">${customLabel} Browser Storage</option>
                    <option value="browserStorage">${customLabel} Collection (Browser Storage)</option>
                    <option value="filter">${customLabel} Collection Filters</option>
                    ${
                      localization &&
                      `<option value="localization">${customLabel} Localization</option>`
                    }
                    <option value="queryParams">${customLabel} Query Parameters</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div id="get-browser-key" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="entityCollection-label-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Collection Name">Collection Name</div>
              </div>
              <div id="browserStorageKeyDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
                <div class="gjs-field">
                  <select class="browserStorageKey form-control form-control-sm options-light"> </select>
                </div>
              </div>
            </div>
             <div class="gjs-row">
              <div id="entityField-label-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Field Name">Field Name</div>
              </div>
              <div id="browserStorageFieldDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
                <div class="gjs-field">
                  <select class="browserStorageFieldKey form-control form-control-sm options-light"> </select>
                </div>
              </div>
            </div>
          </div>

          <div id="get-content-field-container" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="field-label-div" class="gjs-label-wrp">
                <div class="gjs-label" title="Field Name">Field Name</div>
              </div>
              <div id="collection-label-div" class="gjs-label-wrp" style="display: none;">
                <div class="gjs-label" title="Collection Name">Collection Name</div>
              </div>
              <div id="select-field-div" class="gjs-field-wrp gjs-field-wrp--select-field-div" style="display: none;">
                <div class="gjs-field gjs-field--select-field-div">
                  <select class="selectField form-control form-control-sm options-light"> </select>
                </div>
              </div>
              <div id="json-field-div" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
                <div class="gjs-field">
                  <input class="jsonField form-control form-control-sm" placeholder="Ex. name" />
                </div>
              </div>
            </div>
          </div>

          <div id="get-content-filter-container" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="filter-label-div" class="gjs-label-wrp" style="display: none;">
                <div class="gjs-label" title="Collection Filter">Collection Filter</div>
              </div>
              <div id="select-filter-div" class="gjs-field-wrp gjs-field-wrp--select-filter-div" style="display: none;">
                <div class="gjs-field">
                  <select class="select-filter form-control form-control-sm options-light"> </select>
                </div>
              </div>
            </div>
            <div id="filter-external-params-div">
            </div>
          </div>
          <div id="get-content-localization-container" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="localization-label-div" class="gjs-label-wrp" style="display: none;">
                <div class="gjs-label" title="Key">Key</div>
              </div>
              <div id="select-localization-div" class="gjs-field-wrp gjs-field-wrp--select-localization-div" style="display: none;">
                <div class="gjs-field">
                  <select class="select-localization form-control form-control-sm options-light"> </select>
                </div>
              </div>
            </div>
          </div>
          <div id="queryParamContainer" class="gjs-container" style="display: none;">
            <div class="gjs-row">
              <div id="queryParamLabelDiv" class="gjs-label-wrp" style="display: none;">
                <div class="gjs-label" title="Param">Param</div>
                </div>
                <div id="queryParamInputDiv" class="gjs-field-wrp gjs-field-wrp--param-field-div" style="display: none;">
                <div class="gjs-field">
                  <input class="queryParamField form-control form-control-sm" placeholder="Ex. name" />
                </div>
              </div>
            </div>
          </div>
          <div
            id="bslContainer"
            class="gjs-container"
            style="display: none"
          >
            <div class="gjs-row">
              <div id="bslLabelDiv" class="gjs-label-wrp">
                <div class="gjs-label" title="Select storage option">
                  Select storage option
                </div>
              </div>
              <div
                id="bslKeyDiv"
                class="gjs-field-wrp gjs-field-wrp--bsl-key-div"
                style="display: none"
              >
                <div class="gjs-field">
                  <select
                    class="bslKey form-control form-control-sm options-light"
                  >
                    <option value="">- Get Content -</option>
                    <option value="SESSION_STORAGE" selected>Session Storage</option>
                    <option value="LOCAL_STORAGE">Local Storage</option>
                    <option value="COOKIES">Cookies</option>
                    <option value="INDEXED_DB">IndexedDB</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="gjs-row">
              <div id="bslPathLabelDiv" class="gjs-label-wrp">
                <div class="gjs-label" title="JSON key (full path)">JSON key (full path)</div>
              </div>
              <div
                id="bslPathDiv"
                class="gjs-field-wrp gjs-field-wrp--bsl-path-div"
                style="display: none"
              >
                <div class="gjs-field">
                  <input
                    class="bslPathKey form-control form-control-sm"
                    placeholder="Ex. formData.name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
    `;
        const selectGetTextFrom = el.querySelector('.select-getTextFrom');
        const getContentFieldContainer = el.querySelector('#get-content-field-container');
        const getBrowserKey = el.querySelector('#get-browser-key');
        const getContentFilterContainer = el.querySelector('#get-content-filter-container');
        const getContentLocalizationContainer = el.querySelector(
          '#get-content-localization-container',
        );

        const fieldLabelDiv = el.querySelector('#field-label-div');
        const filterLabelDiv = el.querySelector('#filter-label-div');
        const filterExternalParamsDiv = el.querySelector('#filter-external-params-div');
        const collectionLabelDiv = el.querySelector('#collection-label-div');
        const localizationLabelDiv = el.querySelector('#localization-label-div');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const selectFilterDiv = el.querySelector('#select-filter-div');
        const selectFilter = el.querySelector('.select-filter');
        const selectLocalizationDiv = el.querySelector('#select-localization-div');
        const selectLocalization = el.querySelector('.select-localization');

        const jsonFieldDiv = el.querySelector('#json-field-div');
        const jsonField = el.querySelector('.jsonField');
        const browserStorageKeyDiv = el.querySelector('#browserStorageKeyDiv');
        const browserStorageKey = el.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = el.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = el.querySelector('.browserStorageFieldKey');
        const queryParamContainer = el.querySelector('#queryParamContainer');
        const queryParamLabelDiv = el.querySelector('#queryParamLabelDiv');
        const queryParamInputDiv = el.querySelector('#queryParamInputDiv');
        const queryParamInputKey = el.querySelector('.queryParamField');
        jsonField.addEventListener('change', async (ev) => {});
        queryParamInputKey.addEventListener('change', async (ev) => {});
        // Browser Storage Location
        const bslContainer = el.querySelector('#bslContainer');
        const bslKeyDiv = el.querySelector('#bslKeyDiv');
        const bslKey = el.querySelector('.bslKey');
        const bslLabelDiv = el.querySelector('#bslLabelDiv');
        const bslPathLabelDiv = el.querySelector('#bslPathLabelDiv');
        const bslPathDiv = el.querySelector('#bslPathDiv');
        const bslPathKey = el.querySelector('.bslPathKey');

        jsonField.addEventListener('change', async (ev) => {});
        bslKey.addEventListener('change', async (ev) => {});
        bslPathKey.addEventListener('change', async (ev) => {});
        if (selectGetTextFrom) {
          selectGetTextFrom.addEventListener('change', async (ev) => {
            selectField.innerHTML = '';
            let optionHtml = `<option value="" selected>None</option>`;
            if (selectGetTextFrom.value) {
              getContentFieldContainer.style.display = 'block';
              if (selectGetTextFrom.value === 'filter') {
                getContentFilterContainer.style.display = 'block';
              } else {
                getContentFilterContainer.style.display = 'none';
              }
              if (selectGetTextFrom.value === 'localization') {
                getContentLocalizationContainer.style.display = 'block';
              } else {
                getContentLocalizationContainer.style.display = 'none';
              }
              if (selectGetTextFrom.value === 'browserStorage') {
                getBrowserKey.style.display = 'block';
              } else {
                getBrowserKey.style.display = 'none';
              }
              if (selectGetTextFrom.value === 'queryParams') {
                queryParamContainer.style.display = 'block';
              } else {
                queryParamContainer.style.display = 'none';
              }
              if (selectGetTextFrom.value === 'BROWSER_STORAGE_LOCATION') {
                bslContainer.style.display = 'block';
              } else {
                bslContainer.style.display = 'none';
              }
            } else {
              getContentFieldContainer.style.display = 'none';
              getContentFilterContainer.style.display = 'none';
            }
            if (selectGetTextFrom.value === 'session') {
              optionHtml = session ? getFieldOptionsForSelect(session.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionTenant') {
              optionHtml = sessionTenant ? getFieldOptionsForSelect(sessionTenant.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionUserSettings') {
              optionHtml = sessionUserSettings
                ? getFieldOptionsForSelect(sessionUserSettings.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionSubTenant') {
              optionHtml = sessionSubTenant
                ? getFieldOptionsForSelect(sessionSubTenant.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'collection') {
              optionHtml = collection ? getFieldOptionsForSelect(collection.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else if (
              ['previousActionResponse', 'previousActionFormData'].includes(selectGetTextFrom.value)
            ) {
              jsonFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'browserStorage') {
              browserStorageKey.innerHTML = collections
                ? getCollectionOptionsForSelect(collections)
                : '';
              browserStorageFieldKey.innerHTML = `<option value="" selected>None</option>`;
              browserStorageFieldDiv.style.display = 'block';
              browserStorageKeyDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              jsonFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'BROWSER_STORAGE_LOCATION') {
              bslLabelDiv.style.display = 'block';
              bslPathLabelDiv.style.display = 'block';
              bslPathDiv.style.display = 'block';
              bslKeyDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              jsonFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
            } else if (selectGetTextFrom.value === 'filter') {
              optionHtml = collections ? getCollectionOptionsForSelect(collections) : '';
              selectFilter.innerHTML = `<option value="" selected>None</option>`;
              filterLabelDiv.style.display = 'block';
              selectFilterDiv.style.display = 'block';
              selectFieldDiv.style.display = 'block';
              collectionLabelDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              jsonFieldDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'localization') {
              selectLocalization.innerHTML = localization ? localization : '';
              localizationLabelDiv.style.display = 'block';
              selectLocalizationDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              filterLabelDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              selectFilterDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              getBrowserKey.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            } else {
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              filterLabelDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              selectFilterDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              getBrowserKey.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'block';
              queryParamInputDiv.style.display = 'block';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            }
            jsonField.value = '';
            browserStorageKey.value = '';
            queryParamInputKey.value = '';
            bslKey.value = '';
            bslPathKey.value = '';
            selectField.innerHTML = optionHtml;
          });
        }

        selectField.addEventListener('change', (ev) => {
          if (selectGetTextFrom && selectGetTextFrom.value === 'filter') {
            const selectedCollection = collections.find(
              (col) => col.collectionName === ev.target.value,
            );
            selectFilter.innerHTML = getAllCollectionFinderOptions(selectedCollection);
          }
        });
        selectFilterDiv.addEventListener('change', (ev) => {
          if (selectGetTextFrom.value === 'filter') {
            const externalParamsElement = getFinderFieldsOptions(
              collections,
              selectField.value,
              selectFilter.value,
              pageCollectionId,
            );
            filterExternalParamsDiv.innerHTML = externalParamsElement;
          }
        });
        browserStorageKey.addEventListener('change', async (ev) => {
          const selectedCollection = collections.find(
            (col) => col.collectionName === ev.target.value,
          );
          const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
          browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
        });
        return el;
      },
      onEvent({ elInput, component }) {
        const select = elInput.querySelector('.selectField');
        const selectFilter = elInput.querySelector('.select-filter');
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const jsonField = elInput.querySelector('.jsonField');
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        const queryParamInputKey = elInput.querySelector('.queryParamField');
        // Browser Storage Location
        const bslKey = elInput.querySelector('.bslKey');
        const bslPathKey = elInput.querySelector('.bslPathKey');
        const selectGetTextFrom = document.querySelector('.select-getTextFrom');
        const selectGetTextFromValue = selectGetTextFrom ? selectGetTextFrom.value : '';
        let selectFieldValue = select.value || '';
        let jsonFieldValue = jsonField.value || '';
        let browserStorageKeyValue = browserStorageKey.value || '';
        let browserStorageFieldKeyValue = browserStorageFieldKey.value || '';
        let queryParamInputKeyValue = queryParamInputKey.value || '';
        let bslKeyValue = bslKey.value || '';
        let bslPathKeyValue = bslPathKey.value || '';
        const selectedOption = select.options[select.selectedIndex];
        const fieldType = selectedOption ? selectedOption.getAttribute('type') : 'text';
        const selectFilterValue = selectFilter.value || '';
        const selectLocalization = elInput.querySelector('.select-localization');
        const selectedLocalizationOption =
          selectLocalization.options[selectLocalization.selectedIndex];
        const localizationKey = selectedLocalizationOption
          ? selectedLocalizationOption.getAttribute('value')
          : '';
        const selectExternalParams = document.querySelectorAll('.select-external-param');
        if (selectFieldValue.includes("'")) {
          selectFieldValue = selectFieldValue.split("'").join('"');
        }

        if (selectGetTextFromValue) {
          component.set('getContentFrom', selectGetTextFromValue);
          let attr = component.getAttributes();
          [
            dataCollectionFieldName,
            dataSessionFieldName,
            dataSessionTenantFieldName,
            dataSessionUserSettingFieldName,
            dataSessionSubTenantFieldName,
            dataFilter,
            dataFilterCollection,
            'data-previous-action-response',
            'data-previous-action-formdata',
            'data-browser-storage',
            'data-storage-key',
            'data-localization-key',
            'data-query-params',
            'data-bsl',
            'data-bslp',
          ].forEach((key) => {
            if (attr[key]) delete attr[key];
          });
          attr['data-row'] = 'generated';
          component.setAttributes(attr);
          if (selectFieldValue && selectGetTextFromValue === 'session') {
            component.addAttributes({
              [dataSessionFieldName]: selectFieldValue,
              'data-field-type': fieldType,
            });
            component.set('content', '');
            component.set('content', select.options[select.selectedIndex].text);
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionTenant') {
            component.addAttributes({
              [dataSessionTenantFieldName]: selectFieldValue,
              'data-field-type': fieldType,
            });
            component.set('content', '');
            component.set('content', select.options[select.selectedIndex].text);
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionUserSettings') {
            component.addAttributes({
              [dataSessionUserSettingFieldName]: selectFieldValue,
              'data-field-type': fieldType,
            });
            component.set('content', '');
            component.set('content', select.options[select.selectedIndex].text);
          } else if (selectFieldValue && selectGetTextFromValue === 'sessionSubTenant') {
            component.addAttributes({
              [dataSessionSubTenantFieldName]: selectFieldValue,
              'data-field-type': fieldType,
            });
            component.set('content', '');
            component.set('content', select.options[select.selectedIndex].text);
          } else if (selectGetTextFromValue === 'collection') {
            if (selectFieldValue) {
              component.addAttributes({
                [dataCollectionFieldName]: selectFieldValue,
                'data-field-type': fieldType,
              });
              component.set('content', '');
              component.set('content', select.options[select.selectedIndex].text);
            }
          } else if (selectGetTextFromValue === 'filter' && selectFieldValue && selectFilterValue) {
            component.addAttributes({
              [dataFilter]: selectFilterValue,
              [dataFilterCollection]: selectFieldValue,
            });
            component.set('content', selectFilter.options[selectFilter.selectedIndex].text);
          } else if (selectGetTextFromValue === 'previousActionResponse') {
            attr['data-previous-action-response'] = jsonFieldValue ? jsonFieldValue : attr.name;
            delete attr[dataCollectionFieldName];
            delete attr[dataFilter];
            delete attr[dataFilterCollection];
            delete attr['data-previous-action-formdata'];
            delete attr['data-browser-storage'];
            component.set('content', 'Session content');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'previousActionFormData') {
            attr['data-previous-action-formdata'] = jsonFieldValue ? jsonFieldValue : attr.name;
            delete attr[dataCollectionFieldName];
            delete attr[dataFilter];
            delete attr[dataFilterCollection];
            delete attr['data-previous-action-response'];
            delete attr['data-browser-storage'];
            component.set('content', 'Session form content');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'browserStorage') {
            attr['data-browser-storage'] = browserStorageFieldKeyValue
              ? browserStorageFieldKeyValue
              : attr.name;
            attr['data-storage-key'] = browserStorageKeyValue
              ? `entity_${browserStorageKeyValue}`
              : attr.name;
            delete attr[dataCollectionFieldName];
            delete attr[dataFilter];
            delete attr[dataFilterCollection];
            delete attr['data-previous-action-formdata'];
            delete attr['data-previous-action-response'];
            component.set('content', 'Collection (Browser Storage)');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'localization') {
            if (localizationKey) {
              component.addAttributes({
                'data-localization-key': localizationKey,
              });
              component.set('content', '');
              component.set('content', localizationKey);
            }
          } else if (selectGetTextFromValue === 'queryParams') {
            attr['data-query-params'] = queryParamInputKeyValue ? queryParamInputKeyValue : '';
            delete attr[dataCollectionFieldName];
            delete attr[dataFilter];
            delete attr[dataFilterCollection];
            delete attr['data-previous-action-formdata'];
            delete attr['data-previous-action-response'];
            delete attr['data-browser-storage'];
            component.set('content', 'Query Params content');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'BROWSER_STORAGE_LOCATION') {
            attr['data-bsl'] = bslKeyValue ? bslKeyValue : '';
            attr['data-bslp'] = bslPathKeyValue ? bslPathKeyValue : '';
            delete attr[dataCollectionFieldName];
            delete attr[dataFilter];
            delete attr[dataFilterCollection];
            delete attr['data-previous-action-formdata'];
            delete attr['data-previous-action-response'];
            delete attr['data-browser-storage'];
            delete attr['data-query-params'];
            component.set('content', 'Browser storage content');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          }
        } else {
          const attr = component.getAttributes();
          delete attr[dataSessionFieldName];
          delete attr[dataSessionTenantFieldName];
          delete attr[dataSessionUserSettingFieldName];
          delete attr[dataSessionSubTenantFieldName];
          delete attr[dataCollectionFieldName];
          delete attr['data-field-type'];
          delete attr[dataFilter];
          delete attr[dataFilterCollection];
          delete attr['data-previous-action-response'];
          delete attr['data-previous-action-formdata'];
          delete attr['data-browser-storage'];
          delete attr['data-storage-key'];
          delete attr['data-query-params'];
          delete attr['data-bsl'];
          delete attr['data-bslp'];
          component.setAttributes(attr);
          component.set('getContentFrom', '');
          component.set('content', componentContent);
        }
        if (selectExternalParams.length > 0) {
          selectExternalParams.forEach((selectExternalParam) => {
            const selectedExternalParamOption =
              selectExternalParam.options[selectExternalParam.selectedIndex];
            if (selectedExternalParamOption) {
              const params = selectExternalParam.getAttribute('params');
              const value = selectedExternalParamOption.getAttribute('value');
              if (value) {
                component.addAttributes({
                  [`external-params-${params}`]: value,
                });
              } else {
                component.addAttributes({
                  [params]: '',
                });
              }
            }
          });
        }
      },
      async onUpdate({ elInput, component }) {
        const attr = component.getAttributes();
        //Removes empty attribute key
        delete attr[''];
        const getContentFrom = component.get('getContentFrom');
        const selectFilterDiv = elInput.querySelector('#select-filter-div');
        const selectFilter = elInput.querySelector('.select-filter');
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');
        const getContentFieldContainer = elInput.querySelector('#get-content-field-container');
        const getContentFilterContainer = elInput.querySelector('#get-content-filter-container');
        const getBrowserKey = elInput.querySelector('#get-browser-key');

        const fieldLabelDiv = elInput.querySelector('#field-label-div');
        const filterLabelDiv = elInput.querySelector('#filter-label-div');
        const collectionLabelDiv = elInput.querySelector('#collection-label-div');
        const jsonFieldDiv = elInput.querySelector('#json-field-div');
        const jsonField = elInput.querySelector('.jsonField');
        const selectGetTextFrom = elInput.querySelector('.select-getTextFrom');
        const filterExternalParamsDiv = elInput.querySelector('#filter-external-params-div');
        const getContentLocalizationContainer = elInput.querySelector(
          '#get-content-localization-container',
        );
        const localizationLabelDiv = elInput.querySelector('#localization-label-div');
        const selectLocalizationDiv = elInput.querySelector('#select-localization-div');
        const selectLocalization = elInput.querySelector('.select-localization');
        const browserStorageKeyDiv = elInput.querySelector('#browserStorageKeyDiv');
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = elInput.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        const queryParamContainer = elInput.querySelector('#queryParamContainer');
        const queryParamLabelDiv = elInput.querySelector('#queryParamLabelDiv');
        const queryParamInputDiv = elInput.querySelector('#queryParamInputDiv');
        const queryParamInputKey = elInput.querySelector('.queryParamField');
        // Browser Storage Location
        const bslContainer = elInput.querySelector('#bslContainer');
        const bslLabelDiv = elInput.querySelector('#bslLabelDiv');
        const bslKeyDiv = elInput.querySelector('#bslKeyDiv');
        const bslKey = elInput.querySelector('.bslKey');
        const bslPathDiv = elInput.querySelector('#bslPathDiv');
        const bslPathKey = elInput.querySelector('.bslPathKey');
        const localizationKey = attr['data-localization-key'];
        let previousActionFormDataValue = attr['data-previous-action-formdata'] || '';
        let previousActionResponseFieldValue = attr['data-previous-action-response'] || '';
        let entityStorageValue = attr['data-browser-storage'] || '';
        let storageKeyValue = attr['data-storage-key'] || '';
        let jsonFieldValue = '';
        let browserStorageKeyValue = '';
        let browserStorageFieldKeyValue = '';
        let queryParamInputKeyValue = attr['data-query-params'] || '';
        let bslKeyValue = attr['data-bsl'] || '';
        let bslPathKeyValue = attr['data-bslp'] || '';
        if (selectGetTextFrom) {
          selectGetTextFrom.value = getContentFrom || '';
        }

        const externalParams = Object.keys(attr)
          .filter((attribute) => attribute.includes('external-params-'))
          .map((attribute) => ({ [attribute.replace('external-params-', '')]: attr[attribute] }));
        if (
          previousActionFormDataValue ||
          previousActionResponseFieldValue ||
          entityStorageValue ||
          storageKeyValue
        ) {
          if (previousActionFormDataValue) {
            jsonFieldValue = previousActionFormDataValue;
          } else if (previousActionResponseFieldValue) {
            jsonFieldValue = previousActionResponseFieldValue;
          } else if (entityStorageValue || storageKeyValue) {
            browserStorageKeyValue = storageKeyValue.replace('entity_', '');
            browserStorageFieldKeyValue = entityStorageValue;
          }
        }
        if (selectFilter.value) {
          const externalParamsElement = getFinderFieldsOptions(
            collections,
            selectField.value,
            selectFilter.value,
            pageCollectionId,
            externalParams,
          );
          filterExternalParamsDiv.innerHTML = externalParamsElement;
        }

        const sessionFieldValue = attr[dataSessionFieldName] || '';
        const sessionTenantFieldValue = attr[dataSessionTenantFieldName] || '';
        const sessionUserSettingsFieldValue = attr[dataSessionUserSettingFieldName] || '';
        const sessionSubTenantFieldValue = attr[dataSessionSubTenantFieldName] || '';
        const collectionFieldValue = attr[dataCollectionFieldName] || '';
        const dataFilterValue = attr[dataFilter] || '';
        const dataFilterCollectionValue = attr[dataFilterCollection] || '';

        if (getContentFrom) {
          getContentFieldContainer.style.display = 'block';
          let optionHtml = `<option value="" >None</option>`;
          switch (getContentFrom) {
            case 'session':
              selectFieldDiv.style.display = 'block';
              optionHtml = session ? getFieldOptionsForSelect(session.options) : '';
              selectField.innerHTML = optionHtml;
              selectField.value = sessionFieldValue;
              break;
            case 'sessionTenant':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionTenant ? getFieldOptionsForSelect(sessionTenant.options) : '';
              selectField.innerHTML = optionHtml;
              selectField.value = sessionTenantFieldValue;
              break;
            case 'sessionUserSettings':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionUserSettings
                ? getFieldOptionsForSelect(sessionUserSettings.options)
                : '';
              selectField.innerHTML = optionHtml;
              selectField.value = sessionUserSettingsFieldValue;
              break;
            case 'sessionSubTenant':
              selectFieldDiv.style.display = 'block';
              optionHtml = sessionSubTenant
                ? getFieldOptionsForSelect(sessionSubTenant.options)
                : '';
              selectField.innerHTML = optionHtml;
              selectField.value = sessionSubTenantFieldValue;
              break;
            case 'collection':
              selectFieldDiv.style.display = 'block';
              optionHtml = collection ? getFieldOptionsForSelect(collection.options) : '';
              selectField.innerHTML = optionHtml;
              selectField.value = collectionFieldValue;
              break;
            case 'filter':
              selectFieldDiv.style.display = 'block';
              selectFilterDiv.style.display = 'block';
              collectionLabelDiv.style.display = 'block';
              getContentFilterContainer.style.display = 'block';
              filterLabelDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              const selectedCollection = dataFilterCollectionValue
                ? collections.find(
                    (collection) => collection.collectionName === dataFilterCollectionValue,
                  )
                : '';
              optionHtml = collections ? getCollectionOptionsForSelect(collections) : '';
              selectField.innerHTML = optionHtml;
              selectField.value = dataFilterCollectionValue;
              selectFilter.innerHTML = getAllCollectionFinderOptions(selectedCollection);
              selectFilter.value = dataFilterValue;
              break;
            case 'previousActionResponse':
            case 'previousActionFormData':
              jsonFieldDiv.style.display = 'block';
              jsonField.value = jsonFieldValue;
              break;
            case 'browserStorage':
              getBrowserKey.style.display = 'block';
              browserStorageKeyDiv.style.display = 'block';
              browserStorageFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              browserStorageKey.innerHTML = collections
                ? getCollectionOptionsForSelect(collections)
                : '';
              browserStorageKey.value = browserStorageKeyValue;
              const entityCollection = collections.find(
                (col) => col.collectionName === browserStorageKeyValue,
              );
              const fields = await getCollectionFieldTraitOptions(entityCollection, collections);
              browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
              browserStorageFieldKey.value = browserStorageFieldKeyValue;
              break;
            case 'localization':
              selectLocalization.innerHTML = localization ? localization : '';
              selectLocalization.value = localizationKey ? localizationKey : '';
              getContentLocalizationContainer.style.display = 'block';
              localizationLabelDiv.style.display = 'block';
              selectLocalizationDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              break;
            case 'queryParams':
              queryParamContainer.style.display = 'block';
              queryParamLabelDiv.style.display = 'block';
              queryParamInputDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              queryParamInputKey.value = queryParamInputKeyValue;
              getContentFieldContainer.style.display = 'none';
              break;
            case 'BROWSER_STORAGE_LOCATION':
              bslContainer.style.display = 'block';
              bslLabelDiv.style.display = 'block';
              bslPathDiv.style.display = 'block';
              bslKeyDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'none';
              bslKey.value = bslKeyValue;
              bslPathKey.value = bslPathKeyValue;
              getContentFieldContainer.style.display = 'none';
              break;
            default:
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              collectionLabelDiv.style.display = 'none';
              selectFilterDiv.style.display = 'none';
              filterLabelDiv.style.display = 'none';
              localizationLabelDiv.style.display = 'none';
              selectLocalizationDiv.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              break;
          }
        } else {
          getContentFieldContainer.style.display = 'none';
          jsonFieldDiv.style.display = 'none';
          selectFieldDiv.style.display = 'none';
          collectionLabelDiv.style.display = 'none';
          getContentFilterContainer.style.display = 'none';
          selectFilterDiv.style.display = 'none';
          queryParamContainer.style.display = 'none';
          queryParamLabelDiv.style.display = 'none';
          queryParamInputDiv.style.display = 'none';
          bslContainer.style.display = 'none';
          bslLabelDiv.style.display = 'none';
          bslKeyDiv.style.display = 'none';
          bslPathDiv.style.display = 'none';
        }
      },
    });

    traitManager.addType(traits.link.type, {
      createInput({ trait }) {
        componentContent = trait.attributes.content;
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `
    <div id="URL">
    ${
      collection ||
      session ||
      sessionTenant ||
      localization ||
      sessionUserSettings ||
      sessionSubTenant
        ? `
        <div class="gjs-container">
          <div class="gjs-row">
            <div class="gjs-label-wrp">
              <div class="gjs-label" title="Get Content">Get Content</div>
            </div>
            <div id="select-getTextFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getTextFrom">
            <div class="gjs-field">
              <select class="select-getTextFrom form-control form-control-sm options-light">
                <option value="" selected>- Get Content -</option>
                ${
                  collection
                    ? `
                    <option value="collection">Get Data From ${collection.collectionTitle}</option>
                          `
                    : ''
                }
                ${
                  session
                    ? `
                    <option value="session">Get Text From Logged In User</option>
                          `
                    : ''
                }
                ${
                  sessionTenant
                    ? `
                    <option value="sessionTenant">Get Text From Logged In ${sessionTenant.collectionTitle}</option>
                          `
                    : ''
                }
                ${
                  sessionUserSettings
                    ? `
                    <option value="sessionUserSettings">Get Text From Logged In ${sessionUserSettings.collectionTitle}</option>
                          `
                    : ''
                }
                 ${
                   sessionSubTenant
                     ? `
                    <option value="sessionSubTenant">Get Text From Logged In ${sessionSubTenant.collectionTitle}</option>
                          `
                     : ''
                 }
                    <option value="BROWSER_STORAGE_LOCATION">Get Value From Browser Storage</option>
                ${
                  collection
                    ? `<option value="browserStorage">Get Value From Collection (Browser Storage)</option>`
                    : ''
                }
                ${
                  localization &&
                  `<option value="localization">Get Value From Localization</option>`
                }
                  <option value="queryParams">Get Value From Query Parameters</option>
              </select>
              </div>
            </div>
          </div>
        </div>
        `
        : ''
    }
        <div
          id="collection-content-container"
          class="gjs-container"
          style="display: none"
        >
          <div class="gjs-row">
            <div id="text-label-div" class="gjs-label-wrp" style="display: none">
              <div class="gjs-label" title="Field Name">Field Name</div>
            </div>
            <div
              id="select-field-div"
              class="gjs-field-wrp gjs-field-wrp--select-field-div"
              style="display: none"
            >
              <div class="gjs-field">
                <select
                  class="selectField form-control form-control-sm options-light"
                ></select>
              </div>
            </div>
          </div>
          <div class="gjs-row">
            <div id="href-label-div" class="gjs-label-wrp" style="display: none">
              <div class="gjs-label" title="Field Name for URL">Field Name for URL</div>
            </div>
            <div
              id="select-url-field-div"
              class="gjs-field-wrp gjs-field-wrp--select-url-field-div"
              style="display: none"
            >
              <div class="gjs-field">
                <select
                  class="selectURLField form-control form-control-sm options-light"
                ></select>
              </div>
            </div>
          </div>
        </div>
        <div id="get-content-localization-container" class="gjs-container" style="display: none;">
          <div class="gjs-row">
            <div id="localization-label-div" class="gjs-label-wrp" style="display: none;">
              <div class="gjs-label" title="Key">Key</div>
            </div>
            <div id="select-localization-div" class="gjs-field-wrp gjs-field-wrp--select-localization-div" style="display: none;">
              <div class="gjs-field">
                <select class="select-localization form-control form-control-sm options-light"> </select>
              </div>
            </div>
          </div>
        <div id="queryParamContainer" class="gjs-container" style="display: none;">
          <div class="gjs-row">
            <div id="queryParamLabelDiv" class="gjs-label-wrp" style="display: none;">
              <div class="gjs-label" title="Param">Param</div>
              </div>
              <div id="queryParamInputDiv" class="gjs-field-wrp gjs-field-wrp--param-field-div" style="display: none;">
              <div class="gjs-field">
                <input class="queryParamField form-control form-control-sm" placeholder="Ex. name" />
              </div>
            </div>
          </div>
        </div>
        <div id="get-browser-key" class="gjs-container" style="display: none;">
      <div class="gjs-row">
        <div id="entityCollection-label-div" class="gjs-label-wrp">
          <div class="gjs-label" title="Collection Name">Collection Name</div>
        </div>
        <div id="browserStorageKeyDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
          <div class="gjs-field">
            <select class="browserStorageKey form-control form-control-sm options-light"> </select>
          </div>
        </div>
      </div>
        <div class="gjs-row">
        <div id="entityField-label-div" class="gjs-label-wrp">
          <div class="gjs-label" title="Field Name">Field Name</div>
        </div>
        <div id="browserStorageFieldDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
          <div class="gjs-field">
            <select class="browserStorageFieldKey form-control form-control-sm options-light"> </select>
          </div>
        </div>
      </div>
    </div>
    <div
      id="bslContainer"
      class="gjs-container"
      style="display: none"
    >
      <div class="gjs-row">
        <div id="bslLabelDiv" class="gjs-label-wrp">
          <div class="gjs-label" title="Select storage option">
            Select storage option
          </div>
        </div>
        <div
          id="bslKeyDiv"
          class="gjs-field-wrp gjs-field-wrp--bsl-key-div"
          style="display: none"
        >
          <div class="gjs-field">
            <select
              class="bslKey form-control form-control-sm options-light"
            >
              <option value="">- Get Content -</option>
              <option value="SESSION_STORAGE" selected>Session Storage</option>
              <option value="LOCAL_STORAGE">Local Storage</option>
              <option value="COOKIES">Cookies</option>
              <option value="INDEXED_DB">IndexedDB</option>
            </select>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div id="bslPathLabelDiv" class="gjs-label-wrp">
          <div class="gjs-label" title="JSON key (full path)">
            JSON key (full path)
          </div>
        </div>
        <div
          id="bslPathDiv"
          class="gjs-field-wrp gjs-field-wrp--bsl-path-div"
          style="display: none"
        >
          <div class="gjs-field">
            <input
              class="bslPathKey form-control form-control-sm"
              placeholder="Ex. formData.name"
            />
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div id="bslTextLabelDiv" class="gjs-label-wrp">
          <div class="gjs-label" title="Select storage option for Text">
            Select storage option for Text
          </div>
        </div>
        <div
          id="bslTextKeyDiv"
          class="gjs-field-wrp gjs-field-wrp--bsl-text-key-div"
          style="display: none"
        >
          <div class="gjs-field">
            <select
              class="bslTextKey form-control form-control-sm options-light"
            >
              <option value="">- Get Content -</option>
              <option value="SESSION_STORAGE" selected>Session Storage</option>
              <option value="LOCAL_STORAGE">Local Storage</option>
              <option value="COOKIES">Cookies</option>
              <option value="INDEXED_DB">IndexedDB</option>
            </select>
          </div>
        </div>
      </div>
      <div class="gjs-row">
        <div id="bslPathTextLabelDiv" class="gjs-label-wrp">
          <div class="gjs-label" title="JSON key for Text (full path)">
            JSON key for Text (full path)
          </div>
        </div>
        <div
          id="bslPathTextDiv"
          class="gjs-field-wrp gjs-field-wrp--bsl-path-text-div"
          style="display: none"
        >
          <div class="gjs-field">
            <input
              class="bslPathTextKey form-control form-control-sm"
              placeholder="Ex. formData.name (Optional)"
            />
          </div>
        </div>
      </div>
    </div>
    `;
        const selectGetTextFrom = el.querySelector('.select-getTextFrom');
        const collectionContentContainer = el.querySelector('#collection-content-container');
        const selectFieldLabelDiv = el.querySelector('#text-label-div');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const selectURLFieldLabelDiv = el.querySelector('#href-label-div');
        const selectURLFieldDiv = el.querySelector('#select-url-field-div');
        const selectURLField = el.querySelector('.selectURLField');
        const getContentLocalizationContainer = el.querySelector(
          '#get-content-localization-container',
        );
        const localizationLabelDiv = el.querySelector('#localization-label-div');
        const selectLocalizationDiv = el.querySelector('#select-localization-div');
        const selectLocalization = el.querySelector('.select-localization');
        const getBrowserKey = el.querySelector('#get-browser-key');
        const browserStorageKeyDiv = el.querySelector('#browserStorageKeyDiv');
        const browserStorageKey = el.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = el.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = el.querySelector('.browserStorageFieldKey');
        //QueryParam
        const queryParamContainer = el.querySelector('#queryParamContainer');
        const queryParamLabelDiv = el.querySelector('#queryParamLabelDiv');
        const queryParamInputDiv = el.querySelector('#queryParamInputDiv');
        const queryParamInputKey = el.querySelector('.queryParamField');
        // Browser Storage Location
        const bslContainer = el.querySelector('#bslContainer');
        const bslLabelDiv = el.querySelector('#bslLabelDiv');
        const bslKeyDiv = el.querySelector('#bslKeyDiv');
        const bslKey = el.querySelector('.bslKey');
        const bslTextLabelDiv = el.querySelector('#bslTextLabelDiv');
        const bslTextKeyDiv = el.querySelector('#bslTextKeyDiv');
        const bslTextKey = el.querySelector('.bslTextKey');
        const bslPathLabelDiv = el.querySelector('#bslPathLabelDiv');
        const bslPathDiv = el.querySelector('#bslPathDiv');
        const bslPathKey = el.querySelector('.bslPathKey');
        const bslPathTextDiv = el.querySelector('#bslPathTextDiv');
        const bslPathTextKey = el.querySelector('.bslPathTextKey');

        bslKey.addEventListener('change', async (ev) => {});
        bslTextKey.addEventListener('change', async (ev) => {});
        bslPathKey.addEventListener('change', async (ev) => {});
        bslPathTextKey.addEventListener('change', async (ev) => {});

        if (selectGetTextFrom) {
          selectGetTextFrom.addEventListener('change', async (ev) => {
            selectField.innerHTML = '';
            selectURLField.innerHTML = '';
            let optionHtml = `<option value="" selected>- Select One -</option>
                                <option value="">None</option>`;
            let optionTextHtml = `<option value="">- Select Text -</option>`;
            let optionURLHtml = `<option value="">- Select URL -</option>`;
            selectFieldDiv.style.display = 'block';
            selectFieldLabelDiv.style.display = 'block';
            selectURLFieldDiv.style.display = 'block';
            selectURLFieldLabelDiv.style.display = 'block';
            collectionContentContainer.style.display = 'block';
            bslContainer.style.display = 'none';
            queryParamContainer.style.display = 'none';

            switch (selectGetTextFrom.value) {
              case 'session':
                {
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  optionHtml += `${session.options
                    .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                    .join('')}`;
                  selectField.innerHTML = optionHtml;
                  getBrowserKey.style.display = 'none';
                  bslContainer.style.display = 'none';
                  queryParamContainer.style.display = 'none';
                }
                break;
              case 'sessionTenant':
                {
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  optionHtml += `${sessionTenant.options
                    .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                    .join('')}`;
                  selectField.innerHTML = optionHtml;
                  getBrowserKey.style.display = 'none';
                  bslContainer.style.display = 'none';
                  queryParamContainer.style.display = 'none';
                }
                break;
              case 'sessionUserSettings':
                {
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  optionHtml += `${sessionUserSettings.options
                    .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                    .join('')}`;
                  selectField.innerHTML = optionHtml;
                  getBrowserKey.style.display = 'none';
                  bslContainer.style.display = 'none';
                  queryParamContainer.style.display = 'none';
                }
                break;
              case 'sessionSubTenant':
                {
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  optionHtml += `${sessionSubTenant.options
                    .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                    .join('')}`;
                  selectField.innerHTML = optionHtml;
                  getBrowserKey.style.display = 'none';
                  bslContainer.style.display = 'none';
                  queryParamContainer.style.display = 'none';
                }
                break;
              case 'collection':
                {
                  getContentLocalizationContainer.style.display = 'none';
                  getBrowserKey.style.display = 'none';
                  bslContainer.style.display = 'none';
                  let options = collection
                    ? getFieldOptionsForSelect(collection.options, false)
                    : '';
                  optionTextHtml += options;
                  optionURLHtml += options;
                  selectField.innerHTML = optionTextHtml;
                  selectURLField.innerHTML = optionURLHtml;
                  queryParamContainer.style.display = 'none';
                }
                break;
              case 'localization':
                {
                  selectLocalization.innerHTML = localization ? localization : '';
                  getContentLocalizationContainer.style.display = 'block';
                  localizationLabelDiv.style.display = 'block';
                  selectLocalizationDiv.style.display = 'block';
                  collectionContentContainer.style.display = 'none';
                  selectFieldDiv.style.display = 'none';
                  selectFieldLabelDiv.style.display = 'none';
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  getBrowserKey.style.display = 'none';
                  bslContainer.style.display = 'none';
                  queryParamContainer.style.display = 'none';
                }
                break;
              case 'browserStorage':
                {
                  browserStorageKey.innerHTML = collections
                    ? getCollectionOptionsForSelect(collections)
                    : '';
                  browserStorageFieldKey.innerHTML = `<option value="" selected>None</option>`;
                  getBrowserKey.style.display = 'block';
                  browserStorageFieldDiv.style.display = 'block';
                  browserStorageKeyDiv.style.display = 'block';
                  collectionContentContainer.style.display = 'none';
                  selectFieldDiv.style.display = 'none';
                  selectFieldLabelDiv.style.display = 'none';
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  getContentLocalizationContainer.style.display = 'none';
                  bslContainer.style.display = 'none';
                  queryParamContainer.style.display = 'none';
                }
                break;
              case 'BROWSER_STORAGE_LOCATION':
                {
                  bslContainer.style.display = 'block';
                  bslLabelDiv.style.display = 'block';
                  bslKeyDiv.style.display = 'block';
                  bslTextLabelDiv.style.display = 'block';
                  bslTextKeyDiv.style.display = 'block';
                  bslPathLabelDiv.style.display = 'block';
                  bslPathDiv.style.display = 'block';
                  bslPathTextDiv.style.display = 'block';
                  collectionContentContainer.style.display = 'none';
                  selectFieldDiv.style.display = 'none';
                  selectFieldLabelDiv.style.display = 'none';
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  getContentLocalizationContainer.style.display = 'none';
                  localizationLabelDiv.style.display = 'none';
                  selectLocalizationDiv.style.display = 'none';
                  getBrowserKey.style.display = 'none';
                  queryParamContainer.style.display = 'none';
                }
                break;
              case 'queryParams':
                {
                  selectFieldDiv.style.display = 'none';
                  selectURLFieldDiv.style.display = 'none';
                  getContentLocalizationContainer.style.display = 'none';
                  localizationLabelDiv.style.display = 'none';
                  selectLocalizationDiv.style.display = 'none';
                  getBrowserKey.style.display = 'none';
                  bslContainer.style.display = 'none';
                  queryParamContainer.style.display = 'block';
                  queryParamLabelDiv.style.display = 'block';
                  queryParamInputDiv.style.display = 'block';
                }
                break;
              default:
                break;
            }
          });
        }
        browserStorageKey.addEventListener('change', async (ev) => {
          const selectedCollection = collections.find(
            (col) => col.collectionName === ev.target.value,
          );
          const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
          browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
        });
        return el;
      },
      onEvent({ elInput, component }) {
        const collectionContentContainer = elInput.querySelector('#collection-content-container');
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectFieldLabelDiv = elInput.querySelector('#text-label-div');
        const selectURLFieldDiv = elInput.querySelector('#select-url-field-div');
        const selectURLFieldLabelDiv = elInput.querySelector('#href-label-div');
        const select = elInput.querySelector('.selectField');
        const selectURL = elInput.querySelector('.selectURLField');
        const selectGetTextFrom = document.querySelector('.select-getTextFrom');
        const selectGetTextFromValue = selectGetTextFrom
          ? selectGetTextFrom.value
          : 'selectGetTextFrom';
        const selectFieldValue = select.value;
        const selectURLFieldValue = selectURL.value;
        const selectedOption =
          selectURL.options.length > 0 ? selectURL.options[select.selectedIndex] : '';
        const fieldType = selectedOption ? selectedOption.getAttribute('type') : '';
        const selectLocalization = elInput.querySelector('.select-localization');
        const selectedLocalizationOption =
          selectLocalization.options[selectLocalization.selectedIndex];
        const localizationKey = selectedLocalizationOption
          ? selectedLocalizationOption.getAttribute('value')
          : '';
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        const browserStorageKeyValue = browserStorageKey.value || '';
        const browserStorageFieldKeyValue = browserStorageFieldKey.value || '';
        const queryParamInputKey = elInput.querySelector('.queryParamField');
        let queryParamInputKeyValue = queryParamInputKey.value || '';
        // Browser Storage Location
        const bslKey = elInput.querySelector('.bslKey');
        const bslTextKey = elInput.querySelector('.bslTextKey');
        const bslPathKey = elInput.querySelector('.bslPathKey');
        const bslPathTextKey = elInput.querySelector('.bslPathTextKey');
        let bslKeyValue = bslKey.value || '';
        let bslTextKeyValue = bslTextKey.value || '';
        let bslPathKeyValue = bslPathKey.value || '';
        let bslPathTextKeyValue = bslPathTextKey.value || '';

        if (selectGetTextFromValue) {
          component.set('getContentFrom', selectGetTextFromValue);
          if (
            selectFieldValue ||
            selectURLFieldValue ||
            localizationKey ||
            browserStorageFieldKeyValue ||
            browserStorageKeyValue ||
            queryParamInputKeyValue ||
            bslKeyValue ||
            bslTextKeyValue ||
            bslPathKeyValue ||
            bslPathTextKeyValue
          ) {
            let attr = component.getAttributes();
            [
              'data-field-type',
              dataCollectionFieldName,
              dataURLCollectionFieldName,
              // dataSessionFieldName,
              dataSessionTenantFieldName,
              dataSessionUserSettingFieldName,
              dataSessionSubTenantFieldName,
              dataFilter,
              dataFilterCollection,
              'data-previous-action-response',
              'data-previous-action-formdata',
              'data-browser-storage',
              'data-localization-key',
              'data-link-query-params',
              'data-link-bsl',
              'data-link-bslp',
              'data-link-bslt',
              'data-link-bsltp',
            ].forEach((key) => {
              if (attr[key]) delete attr[key];
            });
            attr['data-row'] = 'generated';
            component.setAttributes(attr);
            const cmsComponent = component.closestType('data-table');
            if (cmsComponent) {
              attr['data-gjs'] = 'data-table-link';
              component.addAttributes(attr);
            }

            switch (selectGetTextFromValue) {
              case 'session':
                {
                  if (selectFieldValue) {
                    delete attr['data-gjs'];
                    attr[dataSessionTextFieldName] = selectFieldValue;
                    attr['data-field-type'] = fieldType;
                    component.addAttributes(attr);
                    component.set('content', '');
                    component.set('content', select.options[select.selectedIndex].text);
                  }
                }
                break;
              case 'sessionTenant':
                {
                  if (selectFieldValue) {
                    delete attr['data-gjs'];
                    attr[dataSessionTenantFieldName] = selectFieldValue;
                    attr['data-field-type'] = fieldType;
                    component.addAttributes(attr);
                    component.set('content', '');
                    component.set('content', select.options[select.selectedIndex].text);
                  }
                }
                break;
              case 'sessionUserSettings':
                {
                  if (selectFieldValue) {
                    delete attr['data-gjs'];
                    attr[dataSessionUserSettingFieldName] = selectFieldValue;
                    attr['data-field-type'] = fieldType;
                    component.addAttributes(attr);
                    component.set('content', '');
                    component.set('content', select.options[select.selectedIndex].text);
                  }
                }
                break;
              case 'sessionSubTenant':
                {
                  if (selectFieldValue) {
                    delete attr['data-gjs'];
                    attr[dataSessionSubTenantFieldName] = selectFieldValue;
                    attr['data-field-type'] = fieldType;
                    component.addAttributes(attr);
                    component.set('content', '');
                    component.set('content', select.options[select.selectedIndex].text);
                  }
                }
                break;
              case 'collection':
                {
                  if (selectURLFieldValue) {
                    delete attr['data-gjs'];
                    attr[dataURLCollectionFieldName] = selectURLFieldValue;
                    attr['data-field-type'] = fieldType;
                    component.addAttributes(attr);
                  }
                  if (selectFieldValue) {
                    attr[dataCollectionFieldName] = selectFieldValue;
                  }
                  attr['href'] = '#';
                  component.addAttributes(attr);
                  component.set('content', '');
                  component.set('content', select.options[select.selectedIndex].text);
                }
                break;
              case 'localization':
                {
                  if (localizationKey) {
                    component.addAttributes({
                      'data-localization-key': localizationKey,
                    });
                    component.set('content', '');
                    component.set('content', localizationKey);
                  } else delete attr['data-localization-key'];
                }
                break;
              case 'browserStorage':
                {
                  component.addAttributes({
                    'data-storage-key': `entity_${browserStorageKeyValue}`,
                  });
                  component.addAttributes({
                    'data-browser-storage': browserStorageFieldKeyValue,
                  });
                  component.set('content', 'Collection (Browser Storage)');
                }
                break;
              case 'BROWSER_STORAGE_LOCATION':
                {
                  attr['data-link-bsl'] = bslKeyValue ? bslKeyValue : '';
                  attr['data-link-bslp'] = bslPathKeyValue ? bslPathKeyValue : '';
                  attr['data-link-bslt'] = bslTextKeyValue ? bslTextKeyValue : '';
                  attr['data-link-bsltp'] = bslPathTextKeyValue ? bslPathTextKeyValue : '';

                  [
                    dataCollectionFieldName,
                    dataURLCollectionFieldName,
                    // dataSessionFieldName,
                    dataSessionTextFieldName,
                    dataSessionTenantFieldName,
                    dataSessionUserSettingFieldName,
                    dataSessionSubTenantFieldName,
                    dataFilter,
                    dataFilterCollection,
                    'data-previous-action-response',
                    'data-previous-action-formdata',
                    'data-browser-storage',
                    'data-localization-key',
                    'data-field-type',
                  ].forEach((key) => {
                    if (attr[key]) delete attr[key];
                  });

                  component.set('content', 'Browser storage content');
                  component.setAttributes(attr);
                  collectionContentContainer.style.display = 'none';
                  selectFieldDiv.style.display = 'none';
                  selectFieldLabelDiv.style.display = 'none';
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                }
                break;
              default:
                break;
            }
          } else {
            const attr = component.getAttributes();
            [
              'data-row',
              'data-field-type',
              dataCollectionFieldName,
              dataURLCollectionFieldName,
              // dataSessionFieldName,
              dataSessionTextFieldName,
              dataSessionTenantFieldName,
              dataSessionUserSettingFieldName,
              dataSessionSubTenantFieldName,
              dataFilter,
              dataFilterCollection,
              'data-previous-action-response',
              'data-previous-action-formdata',
              'data-browser-storage',
              'data-localization-key',
              'data-link-bsl',
              'data-link-bslp',
              'data-link-bslt',
              'data-link-bsltp',
            ].forEach((key) => {
              if (attr[key]) delete attr[key];
            });

            component.setAttributes(attr);
            component.set('getContentFrom', '');
            component.set('content', componentContent);
          }
        } else {
          const attr = component.getAttributes();
          [
            'data-row',
            'data-field-type',
            dataCollectionFieldName,
            dataURLCollectionFieldName,
            // dataSessionFieldName,
            dataSessionTextFieldName,
            dataSessionTenantFieldName,
            dataSessionUserSettingFieldName,
            dataSessionSubTenantFieldName,
            dataFilter,
            dataFilterCollection,
            'data-previous-action-response',
            'data-previous-action-formdata',
            'data-browser-storage',
            'data-localization-key',
            'data-link-bsl',
            'data-link-bslp',
            'data-link-bslt',
            'data-link-bsltp',
          ].forEach((key) => {
            if (attr[key]) delete attr[key];
          });

          collectionContentContainer.style.display = 'none';
          selectFieldDiv.style.display = 'none';
          selectFieldLabelDiv.style.display = 'none';
          selectURLFieldDiv.style.display = 'none';
          selectURLFieldLabelDiv.style.display = 'none';
          component.setAttributes(attr);
          component.set('getContentFrom', '');
          component.set('content', componentContent);
        }
      },
      async onUpdate({ elInput, component }) {
        const attr = component.getAttributes();
        //Removes empty attribute key
        delete attr[''];
        const getContentFrom = component.get('getContentFrom');
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectFieldLabelDiv = elInput.querySelector('#text-label-div');
        const selectField = elInput.querySelector('.selectField');
        const selectURLFieldDiv = elInput.querySelector('#select-url-field-div');
        const selectURLFieldLabelDiv = elInput.querySelector('#href-label-div');
        const selectURLField = elInput.querySelector('.selectURLField');

        const sessionFieldValue = attr[dataSessionTextFieldName] || '';
        const sessionTenantFieldValue = attr[dataSessionTenantFieldName] || '';
        const sessionUserSettingsFieldValue = attr[dataSessionUserSettingFieldName] || '';
        const sessionSubTenantFieldValue = attr[dataSessionSubTenantFieldName] || '';
        const collectionFieldValue = attr[dataCollectionFieldName] || '';
        const collectionURLFieldValue = attr[dataURLCollectionFieldName] || '';

        const collectionContentContainer = elInput.querySelector('#collection-content-container');
        const getContentLocalizationContainer = elInput.querySelector(
          '#get-content-localization-container',
        );
        const localizationLabelDiv = elInput.querySelector('#localization-label-div');
        const selectLocalizationDiv = elInput.querySelector('#select-localization-div');
        const selectLocalization = elInput.querySelector('.select-localization');
        const localizationKey = attr['data-localization-key'];

        const getBrowserKey = elInput.querySelector('#get-browser-key');
        const browserStorageKeyDiv = elInput.querySelector('#browserStorageKeyDiv');
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = elInput.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        let browserStorageKeyValue = attr['data-storage-key'] || '';
        browserStorageKeyValue = browserStorageKeyValue.replace('entity_', '');
        const browserStorageFieldKeyValue = attr['data-browser-storage'] || '';
        //Query Params
        const queryParamContainer = elInput.querySelector('#queryParamContainer');
        const queryParamLabelDiv = elInput.querySelector('#queryParamLabelDiv');
        const queryParamInputDiv = elInput.querySelector('#queryParamInputDiv');
        const queryParamInputKey = elInput.querySelector('.queryParamField');
        let queryParamInputKeyValue = attr['data-link-query-params'] || '';

        // Browser Storage Location
        const bslContainer = elInput.querySelector('#bslContainer');
        const bslLabelDiv = elInput.querySelector('#bslLabelDiv');
        const bslKeyDiv = elInput.querySelector('#bslKeyDiv');
        const bslKey = elInput.querySelector('.bslKey');
        const bslTextLabelDiv = elInput.querySelector('#bslTextLabelDiv');
        const bslTextKeyDiv = elInput.querySelector('#bslTextKeyDiv');
        const bslTextKey = elInput.querySelector('.bslTextKey');
        const bslPathDiv = elInput.querySelector('#bslPathDiv');
        const bslPathTextDiv = elInput.querySelector('#bslPathTextDiv');
        const bslPathKey = elInput.querySelector('.bslPathKey');
        const bslPathTextKey = elInput.querySelector('.bslPathTextKey');
        let bslKeyValue = attr['data-link-bsl'] || '';
        let bslPathKeyValue = attr['data-link-bslp'] || '';
        let bslTextKeyValue = attr['data-link-bslt'] || '';
        let bslPathTextKeyValue = attr['data-link-bsltp'] || '';

        const selectGetTextFrom = elInput.querySelector('.select-getTextFrom');
        if (selectGetTextFrom) {
          selectGetTextFrom.value = getContentFrom || '';
        }

        console.log('🚀 ~ file: traits.js:1487 ~ onUpdate ~ getContentFrom:', getContentFrom);
        if (getContentFrom) {
          switch (getContentFrom) {
            case 'session':
              {
                const sessionRadioButton = elInput.querySelector('input[value="session"]');
                sessionRadioButton ? (sessionRadioButton.checked = true) : '';
                let optionHtml = `<option value="" >None</option>`;
                collectionContentContainer.style.display = 'block';
                selectFieldDiv.style.display = 'block';
                selectFieldLabelDiv.style.display = 'block';
                selectURLFieldDiv.style.display = 'none';
                selectURLFieldLabelDiv.style.display = 'none';
                optionHtml += `${session.options
                  .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                  .join('')}`;
                selectField.innerHTML = optionHtml;
                if (sessionFieldValue) {
                  selectField.value = sessionFieldValue;
                }
              }
              break;
            case 'sessionTenant':
              {
                const sessionTenantRadioButton = elInput.querySelector(
                  'input[value="sessionTenant"]',
                );
                sessionTenantRadioButton ? (sessionTenantRadioButton.checked = true) : '';
                let optionHtml = `<option value="" >None</option>`;
                collectionContentContainer.style.display = 'block';
                selectFieldDiv.style.display = 'block';
                selectFieldLabelDiv.style.display = 'block';
                selectURLFieldDiv.style.display = 'none';
                selectURLFieldLabelDiv.style.display = 'none';
                optionHtml += `${sessionTenant.options
                  .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                  .join('')}`;
                selectField.innerHTML = optionHtml;
                if (sessionTenantFieldValue) {
                  selectField.value = sessionTenantFieldValue;
                }
              }
              break;
            case 'sessionUserSettings':
              {
                if (sessionUserSettingsFieldValue) {
                  const sessionUserSettingsRadioButton = elInput.querySelector(
                    'input[value="sessionUserSettings"]',
                  );
                  sessionUserSettingsRadioButton
                    ? (sessionUserSettingsRadioButton.checked = true)
                    : '';
                  let optionHtml = `<option value="" >None</option>`;
                  collectionContentContainer.style.display = 'block';
                  selectFieldDiv.style.display = 'block';
                  selectFieldLabelDiv.style.display = 'block';
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  optionHtml += `${sessionUserSettings.options
                    .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                    .join('')}`;
                  selectField.innerHTML = optionHtml;
                  selectField.value = sessionUserSettingsFieldValue;
                }
              }
              break;
            case 'sessionSubTenant':
              {
                if (sessionSubTenantFieldValue) {
                  const sessionSubTenantRadioButton = elInput.querySelector(
                    'input[value="sessionSubTenant"]',
                  );
                  sessionSubTenantRadioButton ? (sessionSubTenantRadioButton.checked = true) : '';
                  let optionHtml = `<option value="" >None</option>`;
                  collectionContentContainer.style.display = 'block';
                  selectFieldDiv.style.display = 'block';
                  selectFieldLabelDiv.style.display = 'block';
                  selectURLFieldDiv.style.display = 'none';
                  selectURLFieldLabelDiv.style.display = 'none';
                  optionHtml += `${sessionSubTenant.options
                    .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
                    .join('')}`;
                  selectField.innerHTML = optionHtml;
                  selectField.value = sessionSubTenantFieldValue;
                }
              }
              break;
            case 'collection':
              {
                if (collectionFieldValue || collectionURLFieldValue) {
                  const collectionRadioButton = elInput.querySelector('input[value="collection"]');
                  collectionRadioButton ? (collectionRadioButton.checked = true) : '';
                  collectionContentContainer.style.display = 'block';
                  selectFieldDiv.style.display = 'block';
                  selectFieldLabelDiv.style.display = 'block';
                  selectURLFieldDiv.style.display = 'block';
                  selectURLFieldLabelDiv.style.display = 'block';
                  let optionHtml = collection ? getFieldOptionsForSelect(collection.options) : '';
                  selectField.innerHTML = optionHtml;
                  selectField.value = collectionFieldValue;
                  selectURLField.innerHTML = optionHtml;
                  selectURLField.value = collectionURLFieldValue;
                }
              }
              break;
            case 'browserStorage':
              {
                browserStorageKey.innerHTML = collections
                  ? getCollectionOptionsForSelect(collections)
                  : '';
                getBrowserKey.style.display = 'block';
                browserStorageKeyDiv.style.display = 'block';
                browserStorageFieldDiv.style.display = 'block';
                if (browserStorageKeyValue || browserStorageFieldKeyValue) {
                  browserStorageKey.value = browserStorageKeyValue;
                  const entityCollection = collections.find(
                    (col) => col.collectionName === browserStorageKeyValue,
                  );
                  const fields = await getCollectionFieldTraitOptions(
                    entityCollection,
                    collections,
                  );
                  browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
                  browserStorageFieldKey.value = browserStorageFieldKeyValue;
                }
              }
              break;
            case 'localization':
              {
                getContentLocalizationContainer.style.display = 'block';
                localizationLabelDiv.style.display = 'block';
                selectLocalizationDiv.style.display = 'block';
                selectLocalization.innerHTML = localization ? localization : '';
                if (localizationKey) {
                  selectLocalization.value = localizationKey ? localizationKey : '';
                }
              }
              break;
            case 'BROWSER_STORAGE_LOCATION':
              {
                bslContainer.style.display = 'block';
                bslLabelDiv.style.display = 'block';
                bslPathDiv.style.display = 'block';
                bslKeyDiv.style.display = 'block';
                bslTextLabelDiv.style.display = 'block';
                bslTextKeyDiv.style.display = 'block';
                bslPathTextDiv.style.display = 'block';
                collectionContentContainer.style.display = 'none';
                selectFieldDiv.style.display = 'none';
                selectFieldLabelDiv.style.display = 'none';
                selectURLFieldDiv.style.display = 'none';
                selectURLFieldLabelDiv.style.display = 'none';
                getContentLocalizationContainer.style.display = 'none';
                localizationLabelDiv.style.display = 'none';
                selectLocalizationDiv.style.display = 'none';
                getBrowserKey.style.display = 'none';
                browserStorageKeyDiv.style.display = 'none';
                browserStorageFieldDiv.style.display = 'none';
                if (bslKeyValue || bslPathKeyValue || bslPathTextKeyValue) {
                  bslKey.value = bslKeyValue;
                  bslPathKey.value = bslPathKeyValue;
                  bslTextKey.value = bslTextKeyValue;
                  bslPathTextKey.value = bslPathTextKeyValue;
                }
              }
              break;
            case 'queryParams':
              {
                selectFieldDiv.style.display = 'none';
                selectURLFieldDiv.style.display = 'none';
                getContentLocalizationContainer.style.display = 'none';
                localizationLabelDiv.style.display = 'none';
                selectLocalizationDiv.style.display = 'none';
                getBrowserKey.style.display = 'none';
                browserStorageKeyDiv.style.display = 'none';
                browserStorageFieldDiv.style.display = 'none';
                if (queryParamInputKeyValue) {
                  queryParamInputKey.value = queryParamInputKeyValue;
                }
                queryParamContainer.style.display = 'block';
                queryParamInputDiv.style.display = 'block';
                queryParamLabelDiv.style.display = 'block';
              }
              break;
            default:
              break;
          }
        } else {
          collectionContentContainer.style.display = 'none';
          selectURLFieldDiv.style.display = 'none';
          selectURLFieldLabelDiv.style.display = 'none';
          selectFieldDiv.style.display = 'none';
          selectFieldLabelDiv.style.display = 'none';
          getContentLocalizationContainer.style.display = 'none';
          localizationLabelDiv.style.display = 'none';
          selectLocalizationDiv.style.display = 'none';
          getBrowserKey.style.display = 'none';
          browserStorageKeyDiv.style.display = 'none';
          browserStorageFieldDiv.style.display = 'none';
          queryParamContainer.style.display = 'none';
          queryParamInputDiv.style.display = 'none';
          queryParamLabelDiv.style.display = 'none';
          bslContainer.style.display = 'none';
          bslLabelDiv.style.display = 'none';
          bslKeyDiv.style.display = 'none';
          bslPathDiv.style.display = 'none';
          bslTextLabelDiv.style.display = 'none';
          bslTextKeyDiv.style.display = 'none';
          bslPathTextDiv.style.display = 'none';
        }
      },
    });

    traitManager.addType('form-element-trait', {
      createInput({ trait }) {
        const customLabel = trait.attributes.customLabel;
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `
    <div id="URL">
    ${
      collection || session || sessionTenant || sessionUserSettings || sessionSubTenant
        ? `
        <div class="gjs-container">
          <div class="gjs-row">
          <div class="gjs-label-wrp">
          <div class="gjs-label" title="Get Content">Get Content</div>
        </div>
            <div id="select-getTextFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getTextFrom">
            <div class="gjs-field">
              <select class="select-getTextFrom form-control form-control-sm options-light">
                <option value="" selected>- Get Content -</option>
                <option value="staticValue">Give Fixed Value</option>
                ${
                  collection &&
                  `<option value="collection">${customLabel} - ${collection.collectionTitle}</option>`
                }
                ${session && `<option value="session">${customLabel} Logged In User</option>`}
                ${
                  sessionTenant &&
                  `<option value="sessionTenant">${customLabel} Logged In ${sessionTenant.collectionTitle}</option>`
                }
                ${
                  sessionUserSettings &&
                  `<option value="sessionUserSettings">${customLabel} Logged In ${sessionUserSettings.collectionTitle}</option>`
                }
                ${
                  sessionSubTenant &&
                  `<option value="sessionSubTenant">${customLabel} Logged In ${sessionSubTenant.collectionTitle}</option>`
                }
                <option value="BROWSER_STORAGE_LOCATION">${customLabel} Browser Storage</option>
                <option value="browserStorage">${customLabel} Collection (Browser Storage)</option>
                <option value="EXTERNAL_API">${customLabel} External API Response</option>
                <option value="queryParams">${customLabel} Query Parameters</option>
              </select>
              </div>
            </div>
          </div>
        </div>
        `
        : ''
    }
      <div id="get-content-field-container" class="gjs-container">
        <div class="gjs-row">
          <div id="field-label-div" class="gjs-label-wrp">
              <div class="gjs-label" title="Field Name">Field Name</div>
          </div>
          <div id="select-field-div" class="gjs-field-wrp gjs-field-wrp--select-field-div" style="display: none;">
              <div class="gjs-field gjs-field--select-field-div">
                  <select class="selectField form-control form-control-sm options-light"> </select>
              </div>
          </div>
          <div id="select-url-field-div" class="gjs-field-wrp gjs-field-wrp--select-url-field-div" style="display: none;">
              <div class="gjs-field">
                  <select class="selectURLField form-control form-control-sm options-light"> </select>
              </div>
          </div>
          <div id="json-field-div" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
              <div class="gjs-field">
                  <input class="jsonField form-control form-control-sm" placeholder="Ex. name" />
              </div>
          </div>
        </div>
      </div>
      <div id="get-browser-key" class="gjs-container" style="display: none;">
        <div class="gjs-row">
          <div id="entityCollection-label-div" class="gjs-label-wrp">
            <div class="gjs-label" title="Collection Name">Collection Name</div>
          </div>
          <div id="browserStorageKeyDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
            <div class="gjs-field">
              <select class="browserStorageKey form-control form-control-sm options-light"> </select>
            </div>
          </div>
        </div>
        <div class="gjs-row">
          <div id="entityField-label-div" class="gjs-label-wrp">
            <div class="gjs-label" title="Field Name">Field Name</div>
          </div>
          <div id="browserStorageFieldDiv" class="gjs-field-wrp gjs-field-wrp--json-field-div" style="display: none;">
            <div class="gjs-field">
              <select class="browserStorageFieldKey form-control form-control-sm options-light"> </select>
            </div>
          </div>
        </div>
      </div>
      <div id="external-api-container" class="gjs-container" style="display: none">
        <div class="gjs-row">
          <div id="external-api-label-div" class="gjs-label-wrp">
            <div class="gjs-label" title="External API">External API</div>
          </div>
          <div
            id="external-api-select-div"
            class="gjs-field-wrp gjs-field-wrp--json-field-div"
            style="display: none"
          >
            <div class="gjs-field">
              <select
                class="external-api-select form-control form-control-sm options-light"
              ></select>
            </div>
          </div>
        </div>
        <div class="gjs-row">
          <div id="external-api-colfield-label-div" class="gjs-label-wrp">
            <div class="gjs-label" title="Option Value Field">Option Value Field</div>
          </div>
          <div
            id="external-api-colfield-select-div"
            class="gjs-field-wrp gjs-field-wrp--json-field-div"
            style="display: none"
          >
            <div class="gjs-field">
              <select
                class="external-api-colfield-select form-control form-control-sm options-light"
              >
              <option value="" selected>None</option></select>
            </div>
          </div>
        </div>
        <div class="gjs-row">
          <div id="external-api-colfieldlabel-label-div" class="gjs-label-wrp">
            <div class="gjs-label" title="Option Label Field">Option Label Field</div>
          </div>
          <div
            id="external-api-colfieldlabel-select-div"
            class="gjs-field-wrp gjs-field-wrp--json-field-div"
            style="display: none"
          >
            <div class="gjs-field">
              <select
                class="external-api-colfieldlabel-select form-control form-control-sm options-light"
              >
              <option value="" selected>None</option></select>
            </div>
          </div>
        </div>
      </div>
      <div id="queryParamContainer" class="gjs-container" style="display: none;">
        <div class="gjs-row">
          <div id="queryParamLabelDiv" class="gjs-label-wrp" style="display: none;">
            <div class="gjs-label" title="Param">Param</div>
            </div>
            <div id="queryParamInputDiv" class="gjs-field-wrp gjs-field-wrp--param-field-div" style="display: none;">
            <div class="gjs-field">
              <input class="queryParamField form-control form-control-sm" placeholder="Ex. name" />
            </div>
          </div>
        </div>
      </div>
      <div
      id="bslContainer"
      class="gjs-container"
      style="display: none"
      >
        <div class="gjs-row">
          <div id="bslLabelDiv" class="gjs-label-wrp">
            <div class="gjs-label" title="Select storage option">
              Select storage option
            </div>
          </div>
          <div
            id="bslKeyDiv"
            class="gjs-field-wrp gjs-field-wrp--bsl-key-div"
            style="display: none"
          >
            <div class="gjs-field">
              <select
                class="bslKey form-control form-control-sm options-light"
              >
                <option value="">- Get Content -</option>
                <option value="SESSION_STORAGE" selected>Session Storage</option>
                <option value="LOCAL_STORAGE">Local Storage</option>
                <option value="COOKIES">Cookies</option>
                <option value="INDEXED_DB">IndexedDB</option>
              </select>
            </div>
          </div>
        </div>
        <div class="gjs-row">
          <div id="bslPathLabelDiv" class="gjs-label-wrp">
            <div class="gjs-label" title="JSON key (full path)">
              JSON key (full path)
            </div>
          </div>
          <div
            id="bslPathDiv"
            class="gjs-field-wrp gjs-field-wrp--bsl-path-div"
            style="display: none"
          >
            <div class="gjs-field">
              <input
                class="bslPathKey form-control form-control-sm"
                placeholder="Ex. formData.name"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    `;
        const selectGetTextFrom = el.querySelector('.select-getTextFrom');
        const getContentFieldContainer = el.querySelector('#get-content-field-container');
        const fieldLabelDiv = el.querySelector('#field-label-div');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const jsonFieldDiv = el.querySelector('#json-field-div');
        const selectField = el.querySelector('.selectField');
        const jsonField = el.querySelector('.jsonField');
        //Browser Storage Key
        const getBrowserKey = el.querySelector('#get-browser-key');
        const browserStorageKeyDiv = el.querySelector('#browserStorageKeyDiv');
        const browserStorageKey = el.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = el.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = el.querySelector('.browserStorageFieldKey');
        //External API
        const externalApiContainer = el.querySelector('#external-api-container');
        const externalApiSelectDiv = el.querySelector('#external-api-select-div');
        const externalApiSelect = el.querySelector('.external-api-select');
        //External API Collection Field Value
        const externalApiCollectionFieldSelectDiv = el.querySelector(
          '#external-api-colfield-select-div',
        );
        const externalApiCollectionFieldSelect = el.querySelector('.external-api-colfield-select');
        //External API Collection Field Label
        const externalApiCollectionFieldLabelSelectDiv = el.querySelector(
          '#external-api-colfieldlabel-select-div',
        );
        const externalApiCollectionFieldLabelSelect = el.querySelector(
          '.external-api-colfieldlabel-select',
        );
        //Query Params
        const queryParamContainer = el.querySelector('#queryParamContainer');
        const queryParamLabelDiv = el.querySelector('#queryParamLabelDiv');
        const queryParamInputDiv = el.querySelector('#queryParamInputDiv');
        const queryParamInputKey = el.querySelector('.queryParamField');

        // Browser Storage Location
        const bslContainer = el.querySelector('#bslContainer');
        const bslKeyDiv = el.querySelector('#bslKeyDiv');
        const bslKey = el.querySelector('.bslKey');
        const bslLabelDiv = el.querySelector('#bslLabelDiv');
        const bslPathLabelDiv = el.querySelector('#bslPathLabelDiv');
        const bslPathDiv = el.querySelector('#bslPathDiv');
        const bslPathKey = el.querySelector('.bslPathKey');

        jsonField.addEventListener('change', async (ev) => {});
        queryParamInputKey.addEventListener('change', async (ev) => {});
        bslKey.addEventListener('change', async (ev) => {});
        bslPathKey.addEventListener('change', async (ev) => {});
        if (selectGetTextFrom) {
          selectGetTextFrom.addEventListener('change', async (ev) => {
            selectField.innerHTML = '';
            let optionHtml = `<option value="" selected>None</option>`;
            if (selectGetTextFrom.value) {
              getContentFieldContainer.style.display = 'block';
              if (selectGetTextFrom.value === 'queryParams') {
                queryParamContainer.style.display = 'block';
              } else {
                queryParamContainer.style.display = 'none';
              }
              if (selectGetTextFrom.value === 'browserStorage') {
                getBrowserKey.style.display = 'block';
              } else {
                getBrowserKey.style.display = 'none';
              }
              if (selectGetTextFrom.value === 'BROWSER_STORAGE_LOCATION') {
                bslContainer.style.display = 'block';
              } else {
                bslContainer.style.display = 'none';
              }
            } else {
              getContentFieldContainer.style.display = 'none';
            }
            if (selectGetTextFrom.value === 'session') {
              optionHtml = session ? getFieldOptionsForSelect(session.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              externalApiContainer.style.display = 'none';
              externalApiSelectDiv.style.display = 'none';
              externalApiCollectionFieldSelectDiv.style.display = 'none';
              externalApiCollectionFieldLabelSelectDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionTenant') {
              optionHtml = sessionTenant ? getFieldOptionsForSelect(sessionTenant.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              externalApiContainer.style.display = 'none';
              externalApiSelectDiv.style.display = 'none';
              externalApiCollectionFieldSelectDiv.style.display = 'none';
              externalApiCollectionFieldLabelSelectDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionUserSettings') {
              optionHtml = sessionUserSettings
                ? getFieldOptionsForSelect(sessionUserSettings.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'sessionSubTenant') {
              optionHtml = sessionSubTenant
                ? getFieldOptionsForSelect(sessionSubTenant.options)
                : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'collection') {
              optionHtml = collection ? getFieldOptionsForSelect(collection.options) : '';
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              externalApiContainer.style.display = 'none';
              externalApiSelectDiv.style.display = 'none';
              externalApiCollectionFieldSelectDiv.style.display = 'none';
              externalApiCollectionFieldLabelSelectDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
            } else if (
              ['previousActionResponse', 'previousActionFormData'].includes(selectGetTextFrom.value)
            ) {
              jsonFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              externalApiContainer.style.display = 'none';
              externalApiSelectDiv.style.display = 'none';
              externalApiCollectionFieldSelectDiv.style.display = 'none';
              externalApiCollectionFieldLabelSelectDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'browserStorage') {
              browserStorageKey.innerHTML = collections
                ? getCollectionOptionsForSelect(collections)
                : '';
              browserStorageFieldKey.innerHTML = `<option value="" selected>None</option>`;
              browserStorageFieldDiv.style.display = 'block';
              browserStorageKeyDiv.style.display = 'block';
              selectFieldDiv.style.display = 'none';
              externalApiContainer.style.display = 'none';
              externalApiSelectDiv.style.display = 'none';
              externalApiCollectionFieldSelectDiv.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
            } else if (selectGetTextFrom.value === 'EXTERNAL_API') {
              const selectedComponent = editor.getSelected();
              let collectionForm = selectedComponent.closestType('collection-form');
              if (!collectionForm) {
                collectionForm = selectedComponent.closestType('search-form');
              }
              if (collectionForm) {
                const formCollectionName = collectionForm.getAttributes()['data-form-collection'];
                if (formCollectionName) {
                  const formCollection = collections
                    ? collections.find((coll) => coll.collectionName === formCollectionName)
                    : '';
                  const { sourceOfOrigin } = formCollection || {};
                  console.log(
                    '🚀 ~ selectGetTextFrom EventListener EXTERNAL_API ~ sourceOfOrigin:',
                    sourceOfOrigin,
                  );
                  externalApiSelect.innerHTML = externalApis
                    ? getExternalAPIOptionsForSelect(externalApis, sourceOfOrigin)
                    : '';

                  externalApiContainer.style.display = 'block';
                  externalApiSelectDiv.style.display = 'block';
                  externalApiCollectionFieldSelectDiv.style.display = 'block';
                  externalApiCollectionFieldLabelSelectDiv.style.display = 'block';
                  selectFieldDiv.style.display = 'none';
                  fieldLabelDiv.style.display = 'none';
                  getContentFieldContainer.style.display = 'none';
                  bslLabelDiv.style.display = 'none';
                  bslKeyDiv.style.display = 'none';
                  bslPathDiv.style.display = 'none';
                  bslPathLabelDiv.style.display = 'none';
                  queryParamContainer.style.display = 'none';
                  queryParamLabelDiv.style.display = 'none';
                  queryParamInputDiv.style.display = 'none';
                }
              }
            } else if (selectGetTextFrom.value === 'queryParams') {
              jsonFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              externalApiContainer.style.display = 'none';
              externalApiSelectDiv.style.display = 'none';
              externalApiCollectionFieldSelectDiv.style.display = 'none';
              externalApiCollectionFieldLabelSelectDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              queryParamContainer.style.display = 'block';
              queryParamLabelDiv.style.display = 'block';
              queryParamInputDiv.style.display = 'block';
            } else if (selectGetTextFrom.value === 'BROWSER_STORAGE_LOCATION') {
              bslLabelDiv.style.display = 'block';
              bslPathLabelDiv.style.display = 'block';
              bslPathDiv.style.display = 'block';
              bslKeyDiv.style.display = 'block';
              jsonFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              externalApiContainer.style.display = 'none';
              externalApiSelectDiv.style.display = 'none';
              externalApiCollectionFieldSelectDiv.style.display = 'none';
              externalApiCollectionFieldLabelSelectDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
            } else {
              jsonFieldDiv.style.display = 'none';
              selectFieldDiv.style.display = 'none';
              fieldLabelDiv.style.display = 'none';
              getContentFieldContainer.style.display = 'none';
              getBrowserKey.style.display = 'none';
              browserStorageFieldDiv.style.display = 'none';
              browserStorageKeyDiv.style.display = 'none';
              externalApiContainer.style.display = 'none';
              externalApiSelectDiv.style.display = 'none';
              externalApiCollectionFieldSelectDiv.style.display = 'none';
              externalApiCollectionFieldLabelSelectDiv.style.display = 'none';
              queryParamContainer.style.display = 'none';
              queryParamLabelDiv.style.display = 'none';
              queryParamInputDiv.style.display = 'none';
              bslContainer.style.display = 'none';
              bslLabelDiv.style.display = 'none';
              bslKeyDiv.style.display = 'none';
              bslPathDiv.style.display = 'none';
              bslPathLabelDiv.style.display = 'none';
            }
            jsonField.value = '';
            queryParamInputKey.value = '';
            browserStorageKey.value = '';
            bslKey.value = '';
            bslPathKey.value = '';
            selectField.innerHTML = optionHtml;
          });
        }
        browserStorageKey.addEventListener('change', async (ev) => {
          const selectedCollection = collections.find(
            (col) => col.collectionName === ev.target.value,
          );
          const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
          browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
        });
        externalApiSelect.addEventListener('change', async (ev) => {
          const selectedExternalApi = externalApis.find(
            (externalAPI) => externalAPI.uuid === ev.target.value,
          );
          const { responseDataMapping } = selectedExternalApi || {};
          const { selectedCollectionName } = responseDataMapping || {};
          if (selectedCollectionName) {
            const selectedCollection = collections.find(
              (col) => col.collectionName === selectedCollectionName,
            );
            const fields = await getCollectionFieldTraitOptions(selectedCollection, collections);
            externalApiCollectionFieldSelect.innerHTML = getFieldOptionsForSelect(fields);
            externalApiCollectionFieldLabelSelect.innerHTML = getFieldOptionsForSelect(fields);
          }
        });
        return el;
      },
      onEvent({ elInput, component }) {
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const getContentFieldContainer = elInput.querySelector('#get-content-field-container');
        const fieldLabelDiv = elInput.querySelector('#field-label-div');
        const select = elInput.querySelector('.selectField');
        const jsonField = elInput.querySelector('.jsonField');
        const selectGetTextFrom = document.querySelector('.select-getTextFrom');
        const selectGetTextFromValue = selectGetTextFrom ? selectGetTextFrom.value : '';
        const selectFieldValue = select.value;
        const jsonFieldValue = jsonField.value;
        //Browser Storage Key
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        const browserStorageKeyValue = browserStorageKey.value || '';
        const browserStorageFieldKeyValue = browserStorageFieldKey.value || '';
        // Browser Storage Location
        const bslKey = elInput.querySelector('.bslKey');
        const bslPathKey = elInput.querySelector('.bslPathKey');
        let bslKeyValue = bslKey.value || '';
        let bslPathKeyValue = bslPathKey.value || '';
        //External API
        const externalApiContainer = elInput.querySelector('#external-api-container');
        const externalApiSelect = elInput.querySelector('.external-api-select');
        const externalApiSelectValue = externalApiSelect.value || '';
        //External API Collection Field
        const externalApiCollectionFieldSelect = elInput.querySelector(
          '.external-api-colfield-select',
        );
        const externalApiCollectionFieldSelectValue = externalApiCollectionFieldSelect.value || '';
        //External API Collection Field Label
        const externalApiCollectionFieldLabelSelect = elInput.querySelector(
          '.external-api-colfieldlabel-select',
        );
        const externalApiCollectionFieldLabelSelectValue =
          externalApiCollectionFieldLabelSelect.value || '';
        const queryParamInputKey = elInput.querySelector('.queryParamField');
        let attr = component.getAttributes();
        if (selectGetTextFromValue) {
          getContentFieldContainer.style.display = 'block';
          if (selectFieldValue) {
            const id = attr.id;
            attr.id = id;
            delete attr['data-form-element-data-group'];
            if (selectGetTextFromValue && selectGetTextFromValue === 'session') {
              attr['data-form-element-session'] = selectFieldValue;
              selectFieldDiv.style.display = 'block';
              fieldLabelDiv.style.display = 'block';
              delete attr['data-form-element-session-tenant'];
              delete attr['data-form-element-session-user-settings'];
              delete attr['data-form-element-session-sub-tenant'];
              delete attr['data-form-element-collection'];
              delete attr['data-form-element-previous-action-response'];
              delete attr['data-form-element-previous-action-formdata'];
              delete attr['data-element-field-name'];
              delete attr['data-form-element-query-params'];
              delete attr['data-form-element-bsl'];
              delete attr['data-form-element-bslp'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'sessionTenant') {
              attr['data-form-element-session-tenant'] = selectFieldValue;
              delete attr['data-form-element-session'];
              delete attr['data-form-element-session-user-settings'];
              delete attr['data-form-element-session-sub-tenant'];
              delete attr['data-form-element-collection'];
              delete attr['data-form-element-previous-action-response'];
              delete attr['data-form-element-previous-action-formdata'];
              delete attr['data-element-field-name'];
              delete attr['data-form-element-query-params'];
              delete attr['data-form-element-bsl'];
              delete attr['data-form-element-bslp'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'sessionUserSettings') {
              attr['data-form-element-session-user-settings'] = selectFieldValue;
              delete attr['data-form-element-session'];
              delete attr['data-form-element-session-tenant'];
              delete attr['data-form-element-session-sub-tenant'];
              delete attr['data-form-element-collection'];
              delete attr['data-form-element-previous-action-response'];
              delete attr['data-form-element-previous-action-formdata'];
              delete attr['data-element-field-name'];
              delete attr['data-form-element-query-params'];
              delete attr['data-form-element-bsl'];
              delete attr['data-form-element-bslp'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'sessionSubTenant') {
              attr['data-form-element-session-sub-tenant'] = selectFieldValue;
              delete attr['data-form-element-session'];
              delete attr['data-form-element-session-tenant'];
              delete attr['data-form-element-session-user-settings'];
              delete attr['data-form-element-collection'];
              delete attr['data-form-element-previous-action-response'];
              delete attr['data-form-element-previous-action-formdata'];
              delete attr['data-element-field-name'];
              delete attr['data-form-element-query-params'];
              delete attr['data-form-element-bsl'];
              delete attr['data-form-element-bslp'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'collection') {
              attr['data-form-element-collection'] = selectFieldValue;
              delete attr['data-form-element-session'];
              delete attr['data-form-element-session-tenant'];
              delete attr['data-form-element-session-user-settings'];
              delete attr['data-form-element-session-sub-tenant'];
              delete attr['data-form-element-previous-action-response'];
              delete attr['data-form-element-previous-action-formdata'];
              delete attr['data-element-field-name'];
              delete attr['data-form-element-query-params'];
              delete attr['data-form-element-bsl'];
              delete attr['data-form-element-bslp'];
            }
            component.set('content', '');
            component.setAttributes(attr);
          } else if (
            selectGetTextFromValue &&
            selectGetTextFromValue === 'previousActionResponse'
          ) {
            attr['data-form-element-previous-action-response'] = jsonFieldValue
              ? jsonFieldValue
              : attr.name;

            delete attr['data-form-element-collection'];
            delete attr['data-form-element-session'];
            delete attr['data-form-element-session-tenant'];
            delete attr['data-form-element-session-user-settings'];
            delete attr['data-form-element-session-sub-tenant'];
            delete attr['data-form-element-previous-action-formdata'];
            delete attr['data-element-field-name'];
            delete attr['data-form-element-query-params'];
            delete attr['data-form-element-bsl'];
            delete attr['data-form-element-bslp'];
            component.set('content', '');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (
            selectGetTextFromValue &&
            selectGetTextFromValue === 'previousActionFormData'
          ) {
            attr['data-form-element-previous-action-formdata'] = jsonFieldValue
              ? jsonFieldValue
              : attr.name;
            delete attr['data-form-element-collection'];
            delete attr['data-form-element-session'];
            delete attr['data-form-element-session-tenant'];
            delete attr['data-form-element-session-user-settings'];
            delete attr['data-form-element-session-sub-tenant'];
            delete attr['data-form-element-previous-action-response'];
            delete attr['data-element-field-name'];
            delete attr['data-form-element-query-params'];
            delete attr['data-form-element-bsl'];
            delete attr['data-form-element-bslp'];
            component.set('content', '');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
          } else if (
            selectGetTextFromValue &&
            selectGetTextFromValue === 'BROWSER_STORAGE_LOCATION'
          ) {
            attr['data-form-element-bsl'] = bslKeyValue ? bslKeyValue : '';
            attr['data-form-element-bslp'] = bslPathKeyValue ? bslPathKeyValue : '';
            delete attr['data-form-element-collection'];
            delete attr['data-form-element-session'];
            delete attr['data-form-element-session-tenant'];
            delete attr['data-form-element-session-user-settings'];
            delete attr['data-form-element-session-sub-tenant'];
            delete attr['data-form-element-previous-action-formdata'];
            delete attr['data-form-element-previous-action-response'];
            delete attr['data-element-field-name'];
            component.set('content', '');
            component.setAttributes(attr);
            selectFieldDiv.style.display = 'none';
            fieldLabelDiv.style.display = 'none';
            getContentFieldContainer.style.display = 'none';
          } else if (selectGetTextFromValue && selectGetTextFromValue === 'browserStorage') {
            attr['data-storage-key'] = `entity_${browserStorageKeyValue}`;
            attr['data-form-element-browser-storage'] = browserStorageFieldKeyValue;
            component.setAttributes(attr);
            getContentFieldContainer.style.display = 'none';
          } else if (selectGetTextFromValue && selectGetTextFromValue === 'EXTERNAL_API') {
            attr['data-external-api-id'] = externalApiSelectValue;
            attr['data-external-api-field'] = externalApiCollectionFieldSelectValue;
            attr['data-external-api-field-label'] = externalApiCollectionFieldLabelSelectValue;
            component.setAttributes(attr);
            getContentFieldContainer.style.display = 'none';
          } else if (selectGetTextFromValue === 'staticValue') {
            attr['data-element-field-name'] = selectGetTextFromValue;
            delete attr['data-form-element-session'];
            delete attr['data-form-element-session-tenant'];
            delete attr['data-form-element-session-user-settings'];
            delete attr['data-form-element-session-sub-tenant'];
            delete attr['data-form-element-collection'];
            delete attr['data-form-element-previous-action-response'];
            delete attr['data-form-element-previous-action-formdata'];
            delete attr['data-form-element-session-storage'];
            delete attr['data-storage-key'];
            delete attr['data-form-element-browser-storage'];
            delete attr['data-external-api-id'];
            delete attr['data-external-api-field'];
            delete attr['data-external-api-field-label'];
            delete attr['data-form-element-bsl'];
            delete attr['data-form-element-bslp'];
            component.setAttributes(attr);
            component.set('data-element-field-name', selectGetTextFromValue);
            getContentFieldContainer.style.display = 'none';
          } else if (selectGetTextFromValue && selectGetTextFromValue === 'queryParams') {
            attr['data-form-element-query-params'] = queryParamInputKey.value || '';
            delete attr['data-form-element-session'];
            delete attr['data-form-element-session-tenant'];
            delete attr['data-form-element-session-user-settings'];
            delete attr['data-form-element-session-sub-tenant'];
            delete attr['data-form-element-previous-action-response'];
            delete attr['data-form-element-previous-action-formdata'];
            delete attr['data-element-field-name'];
            delete attr['data-form-element-collection'];
            component.setAttributes(attr);
          } else {
            component.setAttributes(attr);
            component.set('content', componentContent);
          }
        } else {
          delete attr['data-form-element-session'];
          delete attr['data-form-element-session-tenant'];
          delete attr['data-form-element-session-user-settings'];
          delete attr['data-form-element-session-sub-tenant'];
          delete attr['data-form-element-collection'];
          delete attr['data-form-element-previous-action-response'];
          delete attr['data-form-element-previous-action-formdata'];
          delete attr['data-form-element-session-storage'];
          delete attr['data-storage-key'];
          delete attr['data-form-element-browser-storage'];
          delete attr['data-external-api-id'];
          delete attr['data-external-api-field'];
          delete attr['data-external-api-field-label'];
          delete attr['data-form-element-query-params'];
          delete attr['data-form-element-bsl'];
          delete attr['data-form-element-bslp'];
          selectFieldDiv.style.display = 'none';
          fieldLabelDiv.style.display = 'none';
          getContentFieldContainer.style.display = 'none';
          externalApiContainer.style.display = 'none';
          component.setAttributes(attr);
          component.set('content', componentContent);
        }
      },
      async onUpdate({ elInput, component }) {
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const getContentFieldContainer = elInput.querySelector('#get-content-field-container');
        const fieldLabelDiv = elInput.querySelector('#field-label-div');
        const selectField = elInput.querySelector('.selectField');
        const jsonFieldDiv = elInput.querySelector('#json-field-div');
        const jsonField = elInput.querySelector('.jsonField');
        const attr = component.getAttributes();
        //Removes empty attribute key
        delete attr[''];
        const sessionFieldValue = attr['data-form-element-session'] || '';
        const sessionTenantFieldValue = attr['data-form-element-session-tenant'] || '';
        const sessionUserSettingsFieldValue = attr['data-form-element-session-user-settings'] || '';
        const sessionSubTenantFieldValue = attr['data-form-element-session-sub-tenant'] || '';
        const collectionFieldValue = attr['data-form-element-collection'] || '';
        const previousActionResponseFieldValue =
          attr['data-form-element-previous-action-response'] || '';
        const previousActionFormDataValue =
          attr['data-form-element-previous-action-formdata'] || '';
        const sessionStorageFieldValue = attr['data-form-element-session-storage'] || '';
        const getValueFrom = attr['data-element-field-name'] || '';
        const selectGetTextFromDiv = elInput.querySelector('#select-getTextFrom-div');
        const selectGetTextFrom = elInput.querySelector('.select-getTextFrom');
        //Browser Storage Key
        const getBrowserKey = elInput.querySelector('#get-browser-key');
        const browserStorageKeyDiv = elInput.querySelector('#browserStorageKeyDiv');
        const browserStorageKey = elInput.querySelector('.browserStorageKey');
        const browserStorageFieldDiv = elInput.querySelector('#browserStorageFieldDiv');
        const browserStorageFieldKey = elInput.querySelector('.browserStorageFieldKey');
        let browserStorageKeyValue = attr['data-storage-key'] || '';
        browserStorageKeyValue = browserStorageKeyValue.replace('entity_', '');
        const browserStorageFieldKeyValue = attr['data-form-element-browser-storage'] || '';
        //External API
        const externalApiContainer = elInput.querySelector('#external-api-container');
        const externalApiSelectDiv = elInput.querySelector('#external-api-select-div');
        const externalApiSelect = elInput.querySelector('.external-api-select');
        const externalApiSelectValue = attr['data-external-api-id'] || '';
        //External API Collection Field
        const externalApiCollectionFieldSelectDiv = elInput.querySelector(
          '#external-api-colfield-select-div',
        );
        const externalApiCollectionFieldSelect = elInput.querySelector(
          '.external-api-colfield-select',
        );
        const externalApiCollectionFieldSelectValue = attr['data-external-api-field'] || '';
        //External API Collection Field Label
        const externalApiCollectionFieldLabelSelectDiv = elInput.querySelector(
          '#external-api-colfieldlabel-select-div',
        );
        const externalApiCollectionFieldLabelSelect = elInput.querySelector(
          '.external-api-colfieldlabel-select',
        );
        const externalApiCollectionFieldLabelSelectValue =
          attr['data-external-api-field-label'] || '';
        const queryParamContainer = elInput.querySelector('#queryParamContainer');
        const queryParamLabelDiv = elInput.querySelector('#queryParamLabelDiv');
        const queryParamInputDiv = elInput.querySelector('#queryParamInputDiv');
        const queryParamInputKey = elInput.querySelector('.queryParamField');
        let queryParamInputKeyValue = attr['data-form-element-query-params'];
        // Browser Storage Location
        const bslContainer = elInput.querySelector('#bslContainer');
        const bslLabelDiv = elInput.querySelector('#bslLabelDiv');
        const bslKeyDiv = elInput.querySelector('#bslKeyDiv');
        const bslKey = elInput.querySelector('.bslKey');
        const bslPathDiv = elInput.querySelector('#bslPathDiv');
        const bslPathKey = elInput.querySelector('.bslPathKey');
        let bslKeyValue = attr['data-form-element-bsl'] || '';
        let bslPathKeyValue = attr['data-form-element-bslp'] || '';
        let selectGetTextFromValue = sessionFieldValue
          ? 'session'
          : collectionFieldValue
          ? 'collection'
          : previousActionResponseFieldValue
          ? 'previousActionResponse'
          : previousActionFormDataValue
          ? 'previousActionFormData'
          : sessionStorageFieldValue
          ? 'sessionStorage'
          : sessionTenantFieldValue
          ? 'sessionTenant'
          : sessionUserSettingsFieldValue
          ? 'sessionUserSettings'
          : sessionSubTenantFieldValue
          ? 'sessionSubTenant'
          : browserStorageKeyValue || browserStorageFieldKeyValue
          ? 'browserStorage'
          : externalApiSelectValue ||
            externalApiCollectionFieldSelectValue ||
            externalApiCollectionFieldLabelSelectValue
          ? 'EXTERNAL_API'
          : bslKeyValue || bslPathKeyValue
          ? 'BROWSER_STORAGE_LOCATION'
          : queryParamInputKeyValue
          ? 'queryParams'
          : '';
        if (getValueFrom === 'staticValue') {
          selectGetTextFromValue = getValueFrom;
        }
        if (selectGetTextFrom && selectGetTextFromValue) {
          selectGetTextFrom.value = selectGetTextFromValue;
        }
        if (selectGetTextFromValue) {
          selectGetTextFromDiv.style.display = 'block';
          getContentFieldContainer.style.display = 'block';
          fieldLabelDiv.style.display = 'block';
          if (sessionFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            optionHtml = session ? getFieldOptionsForSelect(session.options) : '';
            selectField.innerHTML = optionHtml;
            selectField.value = sessionFieldValue;
            jsonFieldDiv.style.display = 'none';
          } else if (sessionTenantFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            optionHtml = sessionTenant ? getFieldOptionsForSelect(sessionTenant.options) : '';
            selectField.innerHTML = optionHtml;
            selectField.value = sessionTenantFieldValue;
            jsonFieldDiv.style.display = 'none';
          } else if (sessionUserSettingsFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            optionHtml = sessionUserSettings
              ? getFieldOptionsForSelect(sessionUserSettings.options)
              : '';
            selectField.innerHTML = optionHtml;
            selectField.value = sessionUserSettingsFieldValue;
            jsonFieldDiv.style.display = 'none';
          } else if (sessionSubTenantFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            optionHtml = sessionSubTenant ? getFieldOptionsForSelect(sessionSubTenant.options) : '';
            selectField.innerHTML = optionHtml;
            selectField.value = sessionSubTenantFieldValue;
            jsonFieldDiv.style.display = 'none';
          } else if (collectionFieldValue) {
            const collectionRadioButton = elInput.querySelector('input[value="collection"]');
            collectionRadioButton ? (collectionRadioButton.checked = true) : '';
            selectFieldDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
            selectField.innerHTML = collection ? getFieldOptionsForSelect(collection.options) : '';
            selectField.value = collectionFieldValue;
            jsonFieldDiv.style.display = 'none';
          } else if (browserStorageKeyValue || browserStorageFieldKeyValue) {
            browserStorageKey.innerHTML = collections
              ? getCollectionOptionsForSelect(collections)
              : '';
            browserStorageKey.value = browserStorageKeyValue;
            const entityCollection = collections.find(
              (col) => col.collectionName === browserStorageKeyValue,
            );
            const fields = await getCollectionFieldTraitOptions(entityCollection, collections);
            browserStorageFieldKey.innerHTML = getFieldOptionsForSelect(fields);
            browserStorageFieldKey.value = browserStorageFieldKeyValue;
            getBrowserKey.style.display = 'block';
            browserStorageKeyDiv.style.display = 'block';
            browserStorageFieldDiv.style.display = 'block';
            getContentFieldContainer.style.display = 'none';
          } else if (
            externalApiSelectValue ||
            externalApiCollectionFieldSelectValue ||
            externalApiCollectionFieldLabelSelectValue
          ) {
            let collectionForm = component.closestType('collection-form');
            if (collectionForm) {
              const formCollectionName = collectionForm.getAttributes()['data-form-collection'];
              if (formCollectionName) {
                const formCollection = collections
                  ? collections.find((coll) => coll.collectionName === formCollectionName)
                  : '';
                const { sourceOfOrigin } = formCollection || {};
                console.log('🚀 ~ onUpdate ~ EXTERNAL_API sourceOfOrigin:', sourceOfOrigin);
                externalApiSelect.innerHTML = externalApis
                  ? getExternalAPIOptionsForSelect(externalApis, sourceOfOrigin)
                  : '';
                externalApiSelect.value = externalApiSelectValue;

                const selectedExternalApi = externalApis.find(
                  (externalAPI) => externalAPI.uuid === externalApiSelectValue,
                );
                const { responseDataMapping } = selectedExternalApi || {};
                const { selectedCollectionName } = responseDataMapping || {};
                if (selectedCollectionName) {
                  const selectedCollection = collections.find(
                    (col) => col.collectionName === selectedCollectionName,
                  );
                  const fields = await getCollectionFieldTraitOptions(
                    selectedCollection,
                    collections,
                  );
                  externalApiCollectionFieldSelect.innerHTML = getFieldOptionsForSelect(fields);
                  externalApiCollectionFieldLabelSelect.innerHTML =
                    getFieldOptionsForSelect(fields);
                  externalApiCollectionFieldSelect.value = externalApiCollectionFieldSelectValue;
                  externalApiCollectionFieldLabelSelect.value =
                    externalApiCollectionFieldLabelSelectValue;

                  externalApiContainer.style.display = 'block';
                  externalApiSelectDiv.style.display = 'block';
                  externalApiCollectionFieldSelectDiv.style.display = 'block';
                  externalApiCollectionFieldLabelSelectDiv.style.display = 'block';
                }
              }
            }
            getContentFieldContainer.style.display = 'none';
          } else if (queryParamInputKeyValue) {
            queryParamInputKey.value = queryParamInputKeyValue;
            fieldLabelDiv.style.display = 'none';
            queryParamContainer.style.display = 'block';
            queryParamInputDiv.style.display = 'block';
            queryParamLabelDiv.style.display = 'block';
          } else if (bslKeyValue || bslPathKeyValue) {
            bslKey.value = bslKeyValue;
            bslPathKey.value = bslPathKeyValue;
            bslContainer.style.display = 'block';
            bslLabelDiv.style.display = 'block';
            bslKeyDiv.style.display = 'block';
            bslPathDiv.style.display = 'block';
            getContentFieldContainer.style.display = 'none';
            fieldLabelDiv.style.display = 'none';
          } else if (selectGetTextFromValue === 'staticValue') {
            selectFieldDiv.style.display = 'none';
            jsonFieldDiv.style.display = 'none';
            fieldLabelDiv.style.display = 'none';
            getContentFieldContainer.style.display = 'none';
          } else {
            jsonField.value =
              previousActionResponseFieldValue ||
              previousActionFormDataValue ||
              sessionStorageFieldValue;
            selectFieldDiv.style.display = 'none';
            jsonFieldDiv.style.display = 'block';
            fieldLabelDiv.style.display = 'block';
          }
        } else {
          selectFieldDiv.style.display = 'none';
          jsonFieldDiv.style.display = 'none';
          fieldLabelDiv.style.display = 'none';
          getContentFieldContainer.style.display = 'none';
          externalApiContainer.style.display = 'none';
          queryParamContainer.style.display = 'none';
          queryParamInputDiv.style.display = 'none';
          queryParamLabelDiv.style.display = 'none';
          bslContainer.style.display = 'none';
          bslLabelDiv.style.display = 'none';
          bslKeyDiv.style.display = 'none';
          bslPathDiv.style.display = 'none';
        }
      },
    });
  } else {
    traitManager.addType(traits.text.type, {
      createInput({ trait }) {
        const el = document.createElement('span');
        el.innerHTML = ``;
        return el;
      },
    });
    traitManager.addType(traits.link.type, {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
